webpackJsonp([1],{

/***/ "+63e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Bf1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+aT9":
/***/ (function(module, exports) {

module.exports = AMap;

/***/ }),

/***/ "1I+l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3WgW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5wrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6a0+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y4Lg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E2Jw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4bU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Irpm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ljw+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad2681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: tab_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_tab_tab = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function injectStyle (ssrContext) {
  __webpack_require__("y0Os")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  tab_tab,
  components_tab_tab,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74122906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("d4Xq")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5a953a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var x_img_staticRenderFns = []
var x_img_esExports = { render: x_img_render, staticRenderFns: x_img_staticRenderFns }
/* harmony default export */ var src_components_x_img = (x_img_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function x_img_injectStyle (ssrContext) {
  __webpack_require__("+Bf1")
}
var x_img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_img___vue_template_functional__ = false
/* styles */
var x_img___vue_styles__ = x_img_injectStyle
/* scopeId */
var x_img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_img___vue_module_identifier__ = null
var x_img_Component = x_img_normalizeComponent(
  components_x_img,
  src_components_x_img,
  x_img___vue_template_functional__,
  x_img___vue_styles__,
  x_img___vue_scopeId__,
  x_img___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (x_img_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js + 1 modules
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("3WgW")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("gWrV")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/getLocation.vue
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var getLocation = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      this_isLocation: false,
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 }
    };
  },

  props: {
    isLocation: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    scenicBound: {
      type: Array
    },
    mapObj: {
      type: Object
    },
    activeImg: {
      type: String
    },
    defaultImg: {
      type: String
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 监听组件本地的展开收起状态 与父组件同步
    // this_isLocation(newV, oldV) {
    //   this.$emit("changeIsLocation", newV);
    // }
    isLocation: function isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
      }
    }
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("持续定位开始");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        var lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            // $.toast("您当前不在景区范围内", "text");
            that.$vux.toast.text("您当前不在景区范围内", "bottom");
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },

    // 是否在一个电子围栏内
    isInBound: function isInBound(lat, lng, bound) {
      var polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0 //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },

    // 移动到当前位置
    moveToCurPosition: function moveToCurPosition() {
      if (this.this_isLocation) {
        this.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
      } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
      }
    },

    // 单次定位 获取定位成功事件
    showPosition: function showPosition(position) {
      console.log("首次定位成功");
      // this.$vux.toast.text("首次定位成功");
      console.log(position);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
        } else {
          console.log("不在电子围栏内");
          // $.toast("您当前不在景区范围内", "text");
          this.$vux.toast.text("您当前不在景区范围内", "bottom");
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },

    // 单次定位 获取定位失败事件
    showErr: function showErr() {
      console.log("首次定位失败");
      this.$vux.toast.text("获取定位失败", "bottom");
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  },
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/getLocation.vue
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var components_getLocation = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      this_isLocation: false,
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 }
    };
  },

  props: {
    isLocation: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    scenicBound: {
      type: Array
    },
    mapObj: {
      type: Object
    },
    activeImg: {
      type: String
    },
    defaultImg: {
      type: String
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 监听组件本地的展开收起状态 与父组件同步
    // this_isLocation(newV, oldV) {
    //   this.$emit("changeIsLocation", newV);
    // }
    isLocation: function isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
      }
    }
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("持续定位开始");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        var lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            // $.toast("您当前不在景区范围内", "text");
            that.$vux.toast.text("您当前不在景区范围内", "bottom");
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },

    // 是否在一个电子围栏内
    isInBound: function isInBound(lat, lng, bound) {
      var polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0 //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },

    // 移动到当前位置
    moveToCurPosition: function moveToCurPosition() {
      if (this.this_isLocation) {
        this.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
      } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
      }
    },

    // 单次定位 获取定位成功事件
    showPosition: function showPosition(position) {
      console.log("首次定位成功");
      // this.$vux.toast.text("首次定位成功");
      console.log(position);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
        } else {
          console.log("不在电子围栏内");
          // $.toast("您当前不在景区范围内", "text");
          this.$vux.toast.text("您当前不在景区范围内", "bottom");
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },

    // 单次定位 获取定位失败事件
    showErr: function showErr() {
      console.log("首次定位失败");
      this.$vux.toast.text("获取定位失败", "bottom");
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  },
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe0118f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/getLocation.vue
var getLocation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['locationBtn',_vm.this_isLocation?'on':'off'],on:{"click":_vm.moveToCurPosition}},[_c('img',{attrs:{"src":_vm.this_isLocation?_vm.activeImg:_vm.defaultImg,"alt":""}})])}
var getLocation_staticRenderFns = []
var getLocation_esExports = { render: getLocation_render, staticRenderFns: getLocation_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_getLocation = (getLocation_esExports);
// CONCATENATED MODULE: ./src/components/getLocation.vue
function getLocation_injectStyle (ssrContext) {
  __webpack_require__("+63e")
}
var getLocation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var getLocation___vue_template_functional__ = false
/* styles */
var getLocation___vue_styles__ = getLocation_injectStyle
/* scopeId */
var getLocation___vue_scopeId__ = "data-v-5fe0118f"
/* moduleIdentifier (server only) */
var getLocation___vue_module_identifier__ = null
var getLocation_Component = getLocation_normalizeComponent(
  components_getLocation,
  selectortype_template_index_0_src_components_getLocation,
  getLocation___vue_template_functional__,
  getLocation___vue_styles__,
  getLocation___vue_scopeId__,
  getLocation___vue_module_identifier__
)

/* harmony default export */ var src_components_getLocation = (getLocation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/leLayer.vue
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var leLayer = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isLelayerShow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    leLayer: {
      type: Object
    },
    mapObj: {
      type: Object
    },
    activeImg: {
      type: String
    },
    defaultImg: {
      type: String
    }
  },
  data: function data() {
    //这里存放数据
    return {
      this_isLelayerShow: null
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 瓦片开关
    isShowLeyaer: function isShowLeyaer() {
      if (this.this_isLelayerShow) {
        this.mapObj.remove(this.leLayer);
      } else {
        this.leLayer.setMap(this.mapObj);
      }
      this.this_isLelayerShow = !this.this_isLelayerShow;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.this_isLelayerShow = this.isShowLeyaer;
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/leLayer.vue
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var components_leLayer = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isLelayerShow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    leLayer: {
      type: Object
    },
    mapObj: {
      type: Object
    },
    activeImg: {
      type: String
    },
    defaultImg: {
      type: String
    }
  },
  data: function data() {
    //这里存放数据
    return {
      this_isLelayerShow: null
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 瓦片开关
    isShowLeyaer: function isShowLeyaer() {
      if (this.this_isLelayerShow) {
        this.mapObj.remove(this.leLayer);
      } else {
        this.leLayer.setMap(this.mapObj);
      }
      this.this_isLelayerShow = !this.this_isLelayerShow;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.this_isLelayerShow = this.isShowLeyaer;
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d0f57d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leLayer.vue
var leLayer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['leLayer-btn',_vm.this_isLelayerShow?'on':''],on:{"click":_vm.isShowLeyaer}},[_c('img',{attrs:{"src":_vm.this_isLelayerShow?_vm.activeImg:_vm.defaultImg,"alt":""}})])}
var leLayer_staticRenderFns = []
var leLayer_esExports = { render: leLayer_render, staticRenderFns: leLayer_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_leLayer = (leLayer_esExports);
// CONCATENATED MODULE: ./src/components/leLayer.vue
function leLayer_injectStyle (ssrContext) {
  __webpack_require__("Irpm")
}
var leLayer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leLayer___vue_template_functional__ = false
/* styles */
var leLayer___vue_styles__ = leLayer_injectStyle
/* scopeId */
var leLayer___vue_scopeId__ = "data-v-76d0f57d"
/* moduleIdentifier (server only) */
var leLayer___vue_module_identifier__ = null
var leLayer_Component = leLayer_normalizeComponent(
  components_leLayer,
  selectortype_template_index_0_src_components_leLayer,
  leLayer___vue_template_functional__,
  leLayer___vue_styles__,
  leLayer___vue_scopeId__,
  leLayer___vue_module_identifier__
)

/* harmony default export */ var src_components_leLayer = (leLayer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detailPop.vue







/* harmony default export */ var detailPop = ({

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Popup: node_modules_vux_src_components_popup,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  props: {
    isDetailPopShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    details: {
      type: Object,
      default: function _default() {
        return {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false, //是否有导览
          id: ""
        };
      }
    }
  },
  data: function data() {

    return {
      isShow: false, //弹窗是否展示


      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0

    };
  },


  computed: {},

  watch: {
    isDetailPopShow: function isDetailPopShow(newV, oldV) {
      this.isShow = newV;
    },
    details: function details(newV, oldV) {
      var that = this;
      if (this.details.audio) {
        console.log("有语音");
        that.audioEnded();
        var audio = document.getElementById("dtAudio");
        audio.src = that.details.audio;
        audio.load();

        audio.addEventListener("canplay", function () {
          that.duration = that.commonFun.transTime(audio.duration);
        });
      } else {
        console.log("没有语音");
      }
    },
    isShow: function isShow(newV, oldV) {
      this.$emit("changeDetailShow", newV);
      if (newV == false) {
        console.log("关闭弹窗");
        if (!document.getElementById("dtAudio").paused) {

          document.getElementById("dtAudio").pause();
        }
      }
    }
  },

  methods: {
    jumpToMap: function jumpToMap() {
      this.$router.push({
        path: "/map",
        name: "map",
        query: { hid: this.details.id }
      });
    },
    location: function location() {
      this.commonFun.openLocation(this.details.title, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), this.details.lat, this.details.lng);
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("dtAudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("dtAudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("dtAudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detailPop.vue







/* harmony default export */ var components_detailPop = ({

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Popup: node_modules_vux_src_components_popup,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  props: {
    isDetailPopShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    details: {
      type: Object,
      default: function _default() {
        return {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false, //是否有导览
          id: ""
        };
      }
    }
  },
  data: function data() {

    return {
      isShow: false, //弹窗是否展示


      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0

    };
  },


  computed: {},

  watch: {
    isDetailPopShow: function isDetailPopShow(newV, oldV) {
      this.isShow = newV;
    },
    details: function details(newV, oldV) {
      var that = this;
      if (this.details.audio) {
        console.log("有语音");
        that.audioEnded();
        var audio = document.getElementById("dtAudio");
        audio.src = that.details.audio;
        audio.load();

        audio.addEventListener("canplay", function () {
          that.duration = that.commonFun.transTime(audio.duration);
        });
      } else {
        console.log("没有语音");
      }
    },
    isShow: function isShow(newV, oldV) {
      this.$emit("changeDetailShow", newV);
      if (newV == false) {
        console.log("关闭弹窗");
        if (!document.getElementById("dtAudio").paused) {

          document.getElementById("dtAudio").pause();
        }
      }
    }
  },

  methods: {
    jumpToMap: function jumpToMap() {
      this.$router.push({
        path: "/map",
        name: "map",
        query: { hid: this.details.id }
      });
    },
    location: function location() {
      this.commonFun.openLocation(this.details.title, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), this.details.lat, this.details.lng);
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("dtAudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("dtAudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("dtAudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01639674","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailPop.vue
var detailPop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"height":"100%","show-mask":false,"hide-on-blur":false,"is-transparent":""},model:{value:(_vm.isDetailPopShow),callback:function ($$v) {_vm.isDetailPopShow=$$v},expression:"isDetailPopShow"}},[_c('audio',{attrs:{"id":"dtAudio","src":""}}),_vm._v(" "),_c('div',{staticClass:"own-mask"},[_c('div',{staticClass:"details-box"},[_c('i',{staticClass:"dt-close",on:{"click":function($event){_vm.isShow=false}}}),_vm._v(" "),_c('div',{staticClass:"dt-top"},[_c('div',{staticClass:"dt-name ellipsis-1"},[_vm._v(_vm._s(_vm.details.title))]),_vm._v(" "),_c('div',{staticClass:"dt-address"},[_c('i',{staticClass:"icon-add"}),_vm._v(" "),_c('span',{staticClass:"dt-add ellipsis-2"},[_vm._v(_vm._s(_vm.details.address))])]),_vm._v(" "),_c('div',{staticClass:"dt-funs"},[_c('div',{staticClass:"dt-fun dt-nav",on:{"click":_vm.location}},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',[_vm._v("导航")])]),_vm._v(" "),(_vm.details.mobile!='')?_c('a',{staticClass:"dt-fun dt-order",attrs:{"href":'tel:' + _vm.details.mobile}},[_c('i',{staticClass:"icon-order"}),_vm._v(" "),_c('span',[_vm._v("预订")])]):_vm._e(),_vm._v(" "),(_vm.details.is_guide==1)?_c('div',{staticClass:"dt-fun dt-guide",on:{"click":_vm.jumpToMap}},[_c('i',{staticClass:"icon-guide"}),_vm._v(" "),_c('span',[_vm._v("导览")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"dt-bottom"},[_c('div',{staticClass:"dt-scroll"},[(_vm.details.imgList.length!=0)?_c('div',{staticClass:"dt-swiper vux-1px-b"},[_c('swiper',{attrs:{"height":"3.1rem","loop":true,"auto":true,"show-dots":false}},_vm._l((_vm.details.imgList),function(item,index){return _c('swiper-item',{key:index},[_c('img',{staticClass:"swiper-img",attrs:{"src":item,"alt":""}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dt-content"},[_c('div',{staticClass:"dt-title-audio"},[_c('div',{staticClass:"dt-content-title"},[_vm._v("简介")]),_vm._v(" "),(_vm.details.audio)?_c('div',{staticClass:"player-box"},[_c('div',{class:['audio-left',_vm.playing?'play':'pause'],attrs:{"id":"audioPlayer"},on:{"click":_vm.audioPlay}}),_vm._v(" "),_c('div',{staticClass:"audio-right"},[_c('div',{staticClass:"progress-bar-bg",attrs:{"id":"progressBarBg"},on:{"mousedown":_vm.progressBarBg}},[_c('span',{style:('left:'+_vm.dotLeft+'%'),attrs:{"id":"progressDot"},on:{"mousedown":_vm.progressDot}}),_vm._v(" "),_c('div',{staticClass:"progress-bar",style:('width:'+_vm.barWidth+'%'),attrs:{"id":"progressBar"}})]),_vm._v(" "),_c('div',{staticClass:"audio-time"},[_c('span',{staticClass:"audio-length-current",attrs:{"id":"audioCurTime"}},[_vm._v(_vm._s(_vm.audioCurTime))]),_vm._v("/\n                      "),_c('span',{staticClass:"audio-length-total"},[_vm._v(_vm._s(_vm.duration))])])])]):_vm._e()]),_vm._v(" "),_c('img',{attrs:{"src":"","alt":""}}),_vm._v(" "),_c('div',{staticClass:"dt-contents",domProps:{"innerHTML":_vm._s(_vm.details.des)}},[_vm._v(_vm._s(_vm.details.des==''?'暂无简介':_vm.details.des))])])])])])])])],1)}
var detailPop_staticRenderFns = []
var detailPop_esExports = { render: detailPop_render, staticRenderFns: detailPop_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_detailPop = (detailPop_esExports);
// CONCATENATED MODULE: ./src/components/detailPop.vue
function detailPop_injectStyle (ssrContext) {
  __webpack_require__("cUee")
  __webpack_require__("SpE7")
}
var detailPop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detailPop___vue_template_functional__ = false
/* styles */
var detailPop___vue_styles__ = detailPop_injectStyle
/* scopeId */
var detailPop___vue_scopeId__ = "data-v-01639674"
/* moduleIdentifier (server only) */
var detailPop___vue_module_identifier__ = null
var detailPop_Component = detailPop_normalizeComponent(
  components_detailPop,
  selectortype_template_index_0_src_components_detailPop,
  detailPop___vue_template_functional__,
  detailPop___vue_styles__,
  detailPop___vue_scopeId__,
  detailPop___vue_module_identifier__
)

/* harmony default export */ var src_components_detailPop = (detailPop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/scenicPop.vue





/* harmony default export */ var scenicPop = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: { Popup: node_modules_vux_src_components_popup },
  props: {
    isScenicPopShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    scenicPopData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isShowMask: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {

    return {
      isShow: false,
      audioSrc: "",
      duration: "00:00", //音频剩余时间
      playing: false
    };
  },


  computed: {},

  watch: {
    isScenicPopShow: function isScenicPopShow(newV, oldV) {
      var that = this;
      this.isShow = newV;
      if (newV) {
        if (this.scenicPopData.audio != null) {
          var audio = document.getElementById("spAudio");
          this.audioSrc = this.GLOBAL.DOMAIN_URL + this.scenicPopData.audio.split(".")[0] + ".mp3";
          audio.load();

          audio.addEventListener("canplay", function () {
            that.duration = that.commonFun.transTime(audio.duration);
          });
        }
      } else {
        var _audio = document.getElementById("spAudio");
        if (_audio.play) {
          document.getElementById("spAudio").pause();
          this.playing = false;
        }
      }
    },
    scenicPopData: function scenicPopData(newV) {
      var that = this;
      if (this.scenicPopData.audio != null) {
        this.playing = false;
        var audio = document.getElementById("spAudio");
        this.audioSrc = this.GLOBAL.DOMAIN_URL + this.scenicPopData.audio.split(".")[0] + ".mp3";
        audio.load();

        audio.addEventListener("canplay", function () {
          that.duration = that.commonFun.transTime(audio.duration);
        });
      }
    },
    isShow: function isShow(newV, oldV) {
      this.$emit("changeScenicPopShow", newV);
    }
  },

  methods: {
    location: function location() {
      this.commonFun.openLocation(this.scenicPopData.name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), this.scenicPopData.latitude_gcj, this.scenicPopData.longitude_gcj);
    },
    jumpToMap: function jumpToMap() {
      this.$router.push({
        path: "/map",
        name: "map",
        query: { hid: this.scenicPopData.id }
      });
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("spAudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded(audio);
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {

      this.duration = this.commonFun.transTime(audio.duration - audio.currentTime);
    },
    audioEnded: function audioEnded(audio) {
      this.playing = false;
      this.duration = this.commonFun.transTime(audio.duration);
    },
    openDetailPop: function openDetailPop() {
      console.log(this.scenicPopData);
      var that = this;
      that.$emit("getScenicDetail", that.scenicPopData);
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/scenicPop.vue





/* harmony default export */ var components_scenicPop = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: { Popup: node_modules_vux_src_components_popup },
  props: {
    isScenicPopShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    scenicPopData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isShowMask: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {

    return {
      isShow: false,
      audioSrc: "",
      duration: "00:00", //音频剩余时间
      playing: false
    };
  },


  computed: {},

  watch: {
    isScenicPopShow: function isScenicPopShow(newV, oldV) {
      var that = this;
      this.isShow = newV;
      if (newV) {
        if (this.scenicPopData.audio != null) {
          var audio = document.getElementById("spAudio");
          this.audioSrc = this.GLOBAL.DOMAIN_URL + this.scenicPopData.audio.split(".")[0] + ".mp3";
          audio.load();

          audio.addEventListener("canplay", function () {
            that.duration = that.commonFun.transTime(audio.duration);
          });
        }
      } else {
        var _audio = document.getElementById("spAudio");
        if (_audio.play) {
          document.getElementById("spAudio").pause();
          this.playing = false;
        }
      }
    },
    scenicPopData: function scenicPopData(newV) {
      var that = this;
      if (this.scenicPopData.audio != null) {
        this.playing = false;
        var audio = document.getElementById("spAudio");
        this.audioSrc = this.GLOBAL.DOMAIN_URL + this.scenicPopData.audio.split(".")[0] + ".mp3";
        audio.load();

        audio.addEventListener("canplay", function () {
          that.duration = that.commonFun.transTime(audio.duration);
        });
      }
    },
    isShow: function isShow(newV, oldV) {
      this.$emit("changeScenicPopShow", newV);
    }
  },

  methods: {
    location: function location() {
      this.commonFun.openLocation(this.scenicPopData.name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), this.scenicPopData.latitude_gcj, this.scenicPopData.longitude_gcj);
    },
    jumpToMap: function jumpToMap() {
      this.$router.push({
        path: "/map",
        name: "map",
        query: { hid: this.scenicPopData.id }
      });
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("spAudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded(audio);
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {

      this.duration = this.commonFun.transTime(audio.duration - audio.currentTime);
    },
    audioEnded: function audioEnded(audio) {
      this.playing = false;
      this.duration = this.commonFun.transTime(audio.duration);
    },
    openDetailPop: function openDetailPop() {
      console.log(this.scenicPopData);
      var that = this;
      that.$emit("getScenicDetail", that.scenicPopData);
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281d0124","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scenicPop.vue
var scenicPop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"hide-on-blur":false,"position":"bottom","height":"2.8rem","is-transparent":"","show-mask":_vm.isShowMask},model:{value:(_vm.isScenicPopShow),callback:function ($$v) {_vm.isScenicPopShow=$$v},expression:"isScenicPopShow"}},[_c('div',{staticClass:"sp-box"},[_c('i',{staticClass:"sp-close",on:{"click":function($event){_vm.isShow=false}}}),_vm._v(" "),_c('audio',{attrs:{"src":_vm.audioSrc,"id":"spAudio"}}),_vm._v(" "),_c('div',{staticClass:"sp-top vux-1px-b"},[_c('img',{staticClass:"sp-img",attrs:{"src":_vm.GLOBAL.DOMAIN_URL+_vm.scenicPopData.thumb_img,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"sp-name",on:{"click":_vm.openDetailPop}},[_vm._v(_vm._s(_vm.scenicPopData.name))]),_vm._v(" "),(_vm.scenicPopData.audio!=null)?_c('div',{staticClass:"sp-play"},[_c('i',{class:['sp-btn',_vm.playing?'on':''],on:{"click":_vm.audioPlay}}),_vm._v(" "),_c('span',{staticClass:"sp-time"},[_vm._v(_vm._s(_vm.duration))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sp-bottom"},[_c('div',{staticClass:"sp-nav",on:{"click":_vm.location}},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',[_vm._v("导  航")])]),_vm._v(" "),(_vm.scenicPopData.is_guide==1)?_c('div',{staticClass:"sp-scenic",on:{"click":_vm.jumpToMap}},[_c('i',{staticClass:"icon-guide"}),_vm._v(" "),_c('span',[_vm._v("导览讲解")])]):_vm._e()])])])],1)}
var scenicPop_staticRenderFns = []
var scenicPop_esExports = { render: scenicPop_render, staticRenderFns: scenicPop_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_scenicPop = (scenicPop_esExports);
// CONCATENATED MODULE: ./src/components/scenicPop.vue
function scenicPop_injectStyle (ssrContext) {
  __webpack_require__("yt6H")
}
var scenicPop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scenicPop___vue_template_functional__ = false
/* styles */
var scenicPop___vue_styles__ = scenicPop_injectStyle
/* scopeId */
var scenicPop___vue_scopeId__ = "data-v-281d0124"
/* moduleIdentifier (server only) */
var scenicPop___vue_module_identifier__ = null
var scenicPop_Component = scenicPop_normalizeComponent(
  components_scenicPop,
  selectortype_template_index_0_src_components_scenicPop,
  scenicPop___vue_template_functional__,
  scenicPop___vue_styles__,
  scenicPop___vue_scopeId__,
  scenicPop___vue_module_identifier__
)

/* harmony default export */ var src_components_scenicPop = (scenicPop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Index.vue



















/* harmony default export */ var Index = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {

    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    LoadMore: vux_src_components_load_more,
    XImg: vux_src_components_x_img,
    Popup: node_modules_vux_src_components_popup,
    TransferDom: transfer_dom["a" /* default */],
    getLocation: src_components_getLocation,
    leLayer: src_components_leLayer,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    detailPop: src_components_detailPop,
    scenicPop: src_components_scenicPop
  },
  data: function data() {

    return {

      tollitImgDefault: "", // 卫生间按钮
      locationImgDefault: "", // 定位按钮
      locationImgActive: "", // 定位按钮选中
      searchImgDefault: "", // 搜索按钮
      viewImgDefault: "", // 手绘按钮
      viewImgActive: "", // 手绘按钮选中

      shopPopup: false, //顶部景区提示pop
      scenicName: null,
      isPopUp: false, //底部进入景区提示组件是否展开收起
      xImgDftSrc: "./static/img/timg.gif",
      xImgNoImg: "./static/img/no_img.jpg",

      mapObj: null, //地图实例
      hid: this.$route.query.hid ? this.$route.query.hid : 15847,
      leLayer: null, //瓦片实例
      isLelayerShow: true, //瓦片展示
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      scenicZoom: 7, //当前景区展示层级
      scenicLat: 30.244132, //当前景区中心点lat
      scenicLng: 120.147476, //当前景区中心点lng
      scenicBound: [], //景区电子围栏范围
      geocoder: null, //地理编码实例
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      curProvinceMarkerArr: [], //省级时 聚合点集合 或者 风情小镇
      curMapMarkers: [], //当前地图上展示的marker点 从curProvinceMarkerArr对应层级中取对应数组


      adCode: -1, //高德的adCode 浙江省3300 用于是否要切换景区时做判断
      citycode: null, //高德地理位置查询得到的城市code
      cityPolygons: [], //行政区域边界线
      areaData: null, //当前景区的所有数据
      type_code: -1, //当前滑块中选中的点位分类的code type_code=32为乡村民宿 要做特殊处理
      is_aggregate: 0, //地图上是否聚合展示点位信息 0否 1是
      area_id: -1, // 当前滑块中选中的市或区的id
      tag_id: -1, // 当前滑块中选中标签id

      curMenuListIndex: 0, //点位分类的选中下标

      curTagListIndex: 0, //当前选中标签的下标
      areaSortResult: [], //当前景区筛选后的结果集


      isMoved: false,
      flags: false,
      screenH: document.documentElement.clientHeight, //屏幕高度
      sliderTop: null,
      sliderBasicHeight: 90, //初始bottom值
      mapHeight: "100%",
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",

      loadMsg: "加载中...",
      isContentTop: true, //子滚动区滚到顶部
      isContentBottom: false, //子滚动区滚到底部部


      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      isScenicPopShow: false,
      scenicPopData: {}
    };
  },


  computed: {
    sliderHeight: function sliderHeight() {

      return this.screenH - parseInt(this.sliderTop.split("px")[0]) + "px";
    }
  },

  watch: {
    shopPopup: function shopPopup(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.shopPopup = false;
        }, 2000);
      }
    }
  },

  methods: {
    getAreaData: function getAreaData(adCode, hid, code) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getComponentsAndScenics.action",
        params: {
          adCode: adCode, //adcode
          hid: hid, //景区id
          type_code: code,
          lat: sessionStorage.getItem("lat"),
          lng: sessionStorage.getItem("lng")

        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);
          that.areaData = data.data.data;

          that.scenicLng = data.data.data.hotspot.longitude_gcj;
          that.scenicLat = data.data.data.hotspot.latitude_gcj;
          that.scenicZoom = data.data.data.hotspot.rank;
          that.adCode = data.data.data.hotspot.adcode;
          that.hid = data.data.data.hotspot.id;
          document.title = data.data.data.hotspot.name;

          that.scenicName = data.data.data.hotspot.name;
          that.shopPopup = true;

          that.area_id = -1;
          that.tag_id = -1;
          if (that.mapObj != null) {} else {

            that.getMap();
          }

          for (var i in data.data.data.menuList) {
            if (code) {

              if (data.data.data.menuList[i].com_code == code) {
                that.curMenuListIndex = i;
                that.type_code = data.data.data.menuList[i].com_code;
                that.areaSortResult = data.data.data.menuList[i].hotspotList;
                that.loadMsg = "全部加载完毕";
                that.is_aggregate = data.data.data.menuList[i].is_aggregate;
                if (that.is_aggregate == 1) {

                  that.setAggregateMarker(data.data.data.menuList[i].areaList);
                } else {

                  that.setUnaggregateMarker(data.data.data.menuList[i].hotspotList, data.data.data.menuList[i].com_code, data.data.data.menuList[i].point_icon, data.data.data.menuList[i].point_picth_icon);
                }
                break;
              }
            } else {

              if (data.data.data.menuList[i].visible == 2) {
                that.curMenuListIndex = i;
                that.type_code = data.data.data.menuList[i].com_code;
                that.areaSortResult = data.data.data.menuList[i].hotspotList;

                that.loadMsg = "全部加载完毕";
                that.is_aggregate = data.data.data.menuList[i].is_aggregate;
                if (that.is_aggregate == 1) {

                  that.setAggregateMarker(data.data.data.menuList[i].areaList);
                } else {

                  that.setUnaggregateMarker(data.data.data.menuList[i].hotspotList, data.data.data.menuList[i].com_code, data.data.data.menuList[i].point_icon, data.data.data.menuList[i].point_picth_icon);
                }
                break;
              }
            }
          }

          for (var _i in data.data.data.iconList) {
            if (data.data.data.iconList[_i].com_id == 6) {

              that.tollitImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
            } else if (data.data.data.iconList[_i].com_id == 7) {

              that.locationImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
              that.locationImgActive = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].picth_icon;
            } else if (data.data.data.iconList[_i].com_id == 8) {

              that.searchImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
            } else if (data.data.data.iconList[_i].com_id == 9) {

              that.viewImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
              that.viewImgActive = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].picth_icon;
            }
          }
        }
      });
    },
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: that.scenicZoom, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      that.isLocation = true;

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      AMap.event.addListener(that.mapObj, "zoomend", function () {
        var lnglat = [that.mapObj.getCenter().lng, that.mapObj.getCenter().lat];
        var zoom = that.mapObj.getZoom();
        if (zoom > 13) {
          that.leLayer.setTileUrl("https://tiles.worldmaipu.com/all/[z]/[x]_[y].png");
        } else {
          that.leLayer.setTileUrl("https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png");
        }

        that.geocoder.getAddress(lnglat, function (status, result) {

          if (status === "complete" && result.info === "OK") {

            var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);

            if (result.regeocode.addressComponent.adcode.substring(0, 2) == "33") {
              if (zoom < 9) {} else if (zoom < 19) {

                console.log("市级及以下");
                if (cityCode == that.adCode) {

                  console.log("没有切换市级 切换不同层级的点");
                  that.mapChangeMarkers();
                } else {}
              }
            }
          }
        });
      });

      AMap.event.addListener(that.mapObj, "moveend", function () {
        console.log("move......................");

        that.mapMoveEnd();
      });

      AMap.event.addListener(that.mapObj, "click", function () {
        console.log("点击地图");
        that.mapHeight = that.screenH - that.sliderBasicHeight + "px";
        that.sliderTop = that.screenH - that.sliderBasicHeight + "px";
        that.isPopUp = false;
      });

      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 180)
        }));
      });

      that.mapObj.plugin("AMap.Geocoder", function () {
        that.geocoder = new AMap.Geocoder({

          city: "浙江省",
          extensions: "base"
        });
      });
    },
    mapMoveEnd: function mapMoveEnd() {
      var that = this;
      var lnglat = [this.mapObj.getCenter().lng, this.mapObj.getCenter().lat];
      var zoom = this.mapObj.getZoom();
      console.log("当前层级：" + zoom);
      this.geocoder.getAddress(lnglat, function (status, result) {

        if (status === "complete" && result.info === "OK") {

          console.log(result);

          var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);
          console.log(cityCode + "..." + that.adCode);

          if (result.regeocode.addressComponent.adcode.substring(0, 2) == "33") {
            console.log("在浙江省内");

            console.log("市级adcode：" + cityCode);
            if (zoom < 9) {
              that.mapObj.remove(that.cityPolygons);
              that.citycode = null;

              console.log("省级5-8");
              if (that.adCode == 3300) {
                return;
              } else {
                that.hid = 15847;
                that.adCode = 3300;
                that.getAreaData(that.adCode, that.hid);
              }
            } else if (zoom < 19) {
              if (that.citycode == result.regeocode.addressComponent.citycode) {} else {
                console.log("画区域边界");
                that.citycode = result.regeocode.addressComponent.citycode;
                AMap.plugin("AMap.DistrictSearch", function () {

                  var district = new AMap.DistrictSearch({

                    extensions: "all",

                    level: "city"
                  });

                  district.search(that.citycode, function (status, result) {

                    var bounds = result.districtList[0].boundaries;
                    that.mapObj.remove(that.cityPolygons);
                    that.cityPolygons = [];
                    if (bounds) {
                      for (var i = 0, l = bounds.length; i < l; i++) {

                        var polygon = new AMap.Polygon({
                          map: that.mapObj,
                          strokeWeight: 2,
                          path: bounds[i],
                          fillOpacity: 0,

                          strokeColor: "#48636e"
                        });
                        that.cityPolygons.push(polygon);
                      }
                    }
                  });
                });
              }

              console.log("市级及以下");
              if (cityCode == that.adCode) {

                console.log("没有切换市级");
              } else {
                that.adCode = cityCode;
                console.log("切换市级");

                that.getAreaData(that.adCode, null, that.type_code);
              }
            }
          } else {
            that.mapObj.remove(that.cityPolygons);
            that.citycode = null;
            console.log("不在浙江省内");
            console.log("市级adcode：" + cityCode);
            if (zoom < 9) {

              console.log("省级5-8");
              if (that.adCode == 3300) {
                return;
              } else {
                that.hid = 15847;
                that.adCode = 3300;
                that.getAreaData(that.adCode, that.hid);
              }
            }
          }
        }
      });
    },
    down: function down() {
      console.log("down..................");
      this.flags = true;
      var touch = void 0;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = moveDiv.offsetLeft;
      this.dy = moveDiv.offsetTop;
    },
    move: function move(e) {
      console.log("move..................");
      this.isMoved = true;
      var sliderResult = document.getElementById("slider_result");
      var sliderTags = document.getElementById("sliderTags");

      if (this.flags) {
        var touch = void 0;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }

        if (sliderResult.querySelector("." + e.target.className)) {

          console.log("在滚动区域滑");
          if (this.isContentTop == true) {

            if (touch.clientY - this.position.y > 0) {} else {

              return;
            }
          } else if (this.isContentBottom == true) {
            if (touch.clientY - this.position.y < 0) {} else {
              return;
            }
          } else {
            return;
          }
        } else if (sliderTags.querySelector("." + e.target.className)) {} else {
          e.preventDefault();
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;

        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;

        if (Math.abs(this.ny) > Math.abs(this.nx)) {

          e.preventDefault();
          if (this.yPum < 0) {
            this.sliderTop = 0 + "px";
          } else {
            this.sliderTop = this.yPum + "px";
          }
        } else {}

        document.addEventListener("touchmove", function (event) {

          event.stopPropagation();
        }, false);
      }
    },
    end: function end() {
      console.log("end..................");

      if (!this.isMoved) {
        return;
      }

      this.flags = false;
      this.isMoved = false;

      var upPercent = (1 - this.yPum / this.screenH).toFixed(2);

      if (upPercent < 0.25) {
        console.log("0---0.25");
        this.mapHeight = this.screenH - this.sliderBasicHeight + "px";
        this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
        this.isPopUp = false;
      } else if (upPercent < 0.75) {

        console.log("0.25---0.75");
        this.mapHeight = this.screenH / 2 + "px";
        this.sliderTop = this.screenH / 2 + "px";
        this.isPopUp = true;
      } else if (upPercent < 2) {
        this.mapHeight = 0 + "px";
        this.sliderTop = 0 + "px";
        this.isPopUp = true;
      }
    },
    sortResultScroll: function sortResultScroll(e) {
      e.stopPropagation();

      var scrollTop = document.getElementById("slider_result").scrollTop;
      var clientHeight = document.getElementById("slider_result").clientHeight;
      var scrollHeight = document.getElementById("slider_result").scrollHeight;
      if (clientHeight == scrollHeight) {

        this.isContentTop = true;
        this.isContentBottom = true;
      } else {

        if (scrollTop == 0) {
          console.log("滚动区在顶部");
          this.isContentTop = true;
        } else if (scrollTop + clientHeight == scrollHeight) {
          console.log("滚动区在底部");
          this.isContentBottom = true;
        } else {
          this.isContentTop = false;
          this.isContentBottom = false;
        }
      }
    },
    changeMenu: function changeMenu(i, code, type, url) {
      console.log("切换menu");

      if (type == 3) {
        window.location.href = url;
      } else {

        if (code != this.type_code) {
          console.log("changeMenu");
          this.type_code = code;
          this.curMenuListIndex = i;
          this.curTagListIndex = 0;
          this.is_aggregate = this.areaData.menuList[this.curMenuListIndex].is_aggregate;
          this.tag_id = -1;
          this.area_id = -1;

          this.changeSort(true);
        }

        if (this.isPopUp) {
          return;
        } else {
          this.isPopUp == true;
          this.sliderTop = "50%";
          this.mapHeight = this.screenH / 2 + "px";
        }
      }
    },
    changeCity: function changeCity(i, id, lat, lng) {
      console.log("切换区域");
      console.log(i + "---" + id);
      if (this.area_id == id) {
        return;
      } else {

        if (lat != 0 && lng != 0) {
          this.mapObj.setCenter([lng, lat]);
        }
        this.area_id = id;
        console.log(this.area_id);

        if (this.is_aggregate == 1) {
          this.changeSort(false);
        } else {
          this.changeSort(true);
        }
      }
    },
    changeTag: function changeTag(i, id) {
      console.log("切换tag");

      if (id == this.tag_id) {
        return;
      } else {

        this.curTagListIndex = i;
        this.tag_id = id;

        this.changeSort(true);
      }
    },
    getAreaSortResult: function getAreaSortResult(needChangeMaker) {
      var that = this;
      this.loadMsg = "加载中...";
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getDeatilDatas.action",
        params: {

          hid: that.hid, //景区id
          type_code: that.type_code, //父区域滑块总分类code
          area_id: that.area_id, //子区域id
          tag_id: that.tag_id, //子区域中左侧筛选id


          is_aggregate: that.is_aggregate, //是否聚合展示
          lat: sessionStorage.getItem("lat"),
          lng: sessionStorage.getItem("lng")
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);

          that.areaSortResult = data.data.data.detailList.hotspotList;

          if (that.areaSortResult == null || that.areaSortResult.length == 0) {
            that.loadMsg = "暂无数据";
          } else {
            that.loadMsg = "全部加载完成";
          }
          if (needChangeMaker) {
            if (that.is_aggregate == 1) {

              that.setAggregateMarker(data.data.data.detailList.areaList);
            } else {

              that.setUnaggregateMarker(data.data.data.detailList.hotspotList, data.data.data.detailList.com_code, data.data.data.detailList.point_icon, data.data.data.detailList.point_picth_icon);
            }
          }
        }
      });
    },
    changeSort: function changeSort(needChangeMaker) {

      this.areaSortResult = [];
      this.getAreaSortResult(needChangeMaker);
    },
    setAggregateMarker: function setAggregateMarker(pointArr) {
      var that = this;

      this.mapObj.remove(this.curMapMarkers);
      this.curMapMarkers = [];
      for (var i in pointArr) {
        var marker = new AMap.Marker({
          map: this.mapObj,
          content: "<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" + pointArr[i].name + "</span><i>" + pointArr[i].counts + "</i>" + "</span></div>",
          position: new AMap.LngLat(pointArr[i].longitude_gcj, pointArr[i].latitude_gcj),

          offset: new AMap.Pixel(-10, -32), //中心点


          extData: {
            hotspot_id: pointArr[i].hotspot_id
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);
          that.hid = extData.hotspot_id;

          that.mapObj.setZoomAndCenter(9, position);
        });
        this.mapObj.remove(marker);

        this.curMapMarkers.push(marker);
      }
      this.mapObj.add(this.curMapMarkers);
    },
    setUnaggregateMarker: function setUnaggregateMarker(pointArr, code, defaultBg, acitveBg) {
      var that = this;

      that.resetCurProvinceMarkerArr();

      for (var i in pointArr) {

        var level = pointArr[i].level;
        var marker = new AMap.Marker({

          content: "<div class='province-poi'><img src='" + that.GLOBAL.DOMAIN_URL + defaultBg + "' class='ua_poi' id='ua_marker" + i + "'><span class='ua_poi_name'>" + pointArr[i].name + "</span></div>",
          position: new AMap.LngLat(pointArr[i].longitude_gcj, pointArr[i].latitude_gcj),
          offset: new AMap.Pixel(-16, -36),

          extData: {
            hotspot_id: pointArr[i].id,
            com_code: code,
            default_bg: defaultBg,
            active_bg: acitveBg,
            id_index: i,
            poiData: pointArr[i],
            level: level
          }
        });
        for (var z = 0; z < that.curProvinceMarkerArr.length; z++) {

          var startZoom = level - that.mapMinZoom;
          if (startZoom <= z) {
            that.curProvinceMarkerArr[z].push(marker);
          }
        }
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);
          that.mapObj.setCenter(position);

          if (extData.poiData.com_code == 20) {

            that.get({
              url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
              params: {
                id: extData.hotspot_id //景区id
              },
              isShowLoading: false,
              success: function success(data) {
                console.log(data.data);

                that.details.is_guide = extData.poiData.is_guide;
                that.details.id = extData.hotspot_id;
                that.details.imgList = data.data.data.imgs;
                that.details.title = data.data.data.homeStays.homestay_name;
                that.details.address = data.data.data.homeStays.address;
                that.details.des = data.data.data.homeStays.characters;
                that.details.mobile = data.data.data.homeStays.mobile;
                that.details.lat = data.data.data.homeStays.latitude;
                that.details.lng = data.data.data.homeStays.longitude;
                that.isDetailPopShow = true;
              }
            });
          } else {

            var data = {
              address: extData.poiData.address,
              audio: extData.poiData.audio,
              com_code: extData.poiData.com_code,
              id: extData.hotspot_id,
              is_guide: extData.poiData.is_guide,
              latitude_gcj: extData.poiData.latitude_gcj,
              longitude_gcj: extData.poiData.longitude_gcj,
              name: extData.poiData.name,
              thumb_img: extData.poiData.thumb_img
            };
            that.scenicPopData = data;
            that.isScenicPopShow = true;
          }
        });
      }

      that.mapChangeMarkers();
    },
    resetCurProvinceMarkerArr: function resetCurProvinceMarkerArr() {
      this.curProvinceMarkerArr = [];
      for (var i = this.mapMinZoom; i < this.mapMaxZoom + 1; i++) {

        this.curProvinceMarkerArr.push([]);
      }
    },
    mapChangeMarkers: function mapChangeMarkers() {
      console.log("市级切换层级 的点位");
      var zoom = this.mapObj.getZoom();
      this.mapObj.remove(this.curMapMarkers);
      this.curMapMarkers = [];
      this.curMapMarkers = this.curProvinceMarkerArr[zoom - this.mapMinZoom];
      console.log("加载第" + zoom + "级的点");
      this.mapObj.add(this.curMapMarkers);
    },
    jumpTo: function jumpTo(obj) {
      var that = this;
      if (obj.com_code == 20) {

        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
          params: {
            id: obj.id //景区id
          },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data);
            var details = {};

            details.is_guide = obj.is_guide;
            details.id = obj.id;
            details.imgList = data.data.data.imgs;
            details.title = data.data.data.homeStays.homestay_name;
            details.address = data.data.data.homeStays.address;
            details.des = data.data.data.homeStays.characters;
            details.mobile = data.data.data.homeStays.mobile;
            details.lat = data.data.data.homeStays.latitude;
            details.lng = data.data.data.homeStays.longitude;

            that.details = details;
            that.isDetailPopShow = true;
          }
        });
      } else {

        var data = obj;
        console.log(obj);
        that.scenicPopData = data;
        that.isScenicPopShow = true;
      }
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      if (val == false) {
        this.details = {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false,
          id: ""
        }; //清空详情组件的details props
      }
    },
    changeScenicPop: function changeScenicPop(val) {
      this.isScenicPopShow = val;
    },
    getScenicDetailFromScenicPop: function getScenicDetailFromScenicPop(val) {
      var that = this;

      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: val.id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = val.is_guide;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          for (var i in data.data.data.imgList) {
            details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
        }
      });
      this.isScenicPopShow = false;
      this.isDetailPopShow = true;
    }
  },

  created: function created() {
    this.getAreaData(null, this.hid);
  },
  mounted: function mounted() {
    console.log(this.$route.query);

    this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
    this.mapHeight = this.screenH - this.sliderBasicHeight + "px";
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Index.vue



















/* harmony default export */ var pages_Index = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {

    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    LoadMore: vux_src_components_load_more,
    XImg: vux_src_components_x_img,
    Popup: node_modules_vux_src_components_popup,
    TransferDom: transfer_dom["a" /* default */],
    getLocation: src_components_getLocation,
    leLayer: src_components_leLayer,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    detailPop: src_components_detailPop,
    scenicPop: src_components_scenicPop
  },
  data: function data() {

    return {

      tollitImgDefault: "", // 卫生间按钮
      locationImgDefault: "", // 定位按钮
      locationImgActive: "", // 定位按钮选中
      searchImgDefault: "", // 搜索按钮
      viewImgDefault: "", // 手绘按钮
      viewImgActive: "", // 手绘按钮选中

      shopPopup: false, //顶部景区提示pop
      scenicName: null,
      isPopUp: false, //底部进入景区提示组件是否展开收起
      xImgDftSrc: "./static/img/timg.gif",
      xImgNoImg: "./static/img/no_img.jpg",

      mapObj: null, //地图实例
      hid: this.$route.query.hid ? this.$route.query.hid : 15847,
      leLayer: null, //瓦片实例
      isLelayerShow: true, //瓦片展示
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      scenicZoom: 7, //当前景区展示层级
      scenicLat: 30.244132, //当前景区中心点lat
      scenicLng: 120.147476, //当前景区中心点lng
      scenicBound: [], //景区电子围栏范围
      geocoder: null, //地理编码实例
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      curProvinceMarkerArr: [], //省级时 聚合点集合 或者 风情小镇
      curMapMarkers: [], //当前地图上展示的marker点 从curProvinceMarkerArr对应层级中取对应数组


      adCode: -1, //高德的adCode 浙江省3300 用于是否要切换景区时做判断
      citycode: null, //高德地理位置查询得到的城市code
      cityPolygons: [], //行政区域边界线
      areaData: null, //当前景区的所有数据
      type_code: -1, //当前滑块中选中的点位分类的code type_code=32为乡村民宿 要做特殊处理
      is_aggregate: 0, //地图上是否聚合展示点位信息 0否 1是
      area_id: -1, // 当前滑块中选中的市或区的id
      tag_id: -1, // 当前滑块中选中标签id

      curMenuListIndex: 0, //点位分类的选中下标

      curTagListIndex: 0, //当前选中标签的下标
      areaSortResult: [], //当前景区筛选后的结果集


      isMoved: false,
      flags: false,
      screenH: document.documentElement.clientHeight, //屏幕高度
      sliderTop: null,
      sliderBasicHeight: 90, //初始bottom值
      mapHeight: "100%",
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",

      loadMsg: "加载中...",
      isContentTop: true, //子滚动区滚到顶部
      isContentBottom: false, //子滚动区滚到底部部


      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      isScenicPopShow: false,
      scenicPopData: {}
    };
  },


  computed: {
    sliderHeight: function sliderHeight() {

      return this.screenH - parseInt(this.sliderTop.split("px")[0]) + "px";
    }
  },

  watch: {
    shopPopup: function shopPopup(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.shopPopup = false;
        }, 2000);
      }
    }
  },

  methods: {
    getAreaData: function getAreaData(adCode, hid, code) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getComponentsAndScenics.action",
        params: {
          adCode: adCode, //adcode
          hid: hid, //景区id
          type_code: code,
          lat: sessionStorage.getItem("lat"),
          lng: sessionStorage.getItem("lng")

        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);
          that.areaData = data.data.data;

          that.scenicLng = data.data.data.hotspot.longitude_gcj;
          that.scenicLat = data.data.data.hotspot.latitude_gcj;
          that.scenicZoom = data.data.data.hotspot.rank;
          that.adCode = data.data.data.hotspot.adcode;
          that.hid = data.data.data.hotspot.id;
          document.title = data.data.data.hotspot.name;

          that.scenicName = data.data.data.hotspot.name;
          that.shopPopup = true;

          that.area_id = -1;
          that.tag_id = -1;
          if (that.mapObj != null) {} else {

            that.getMap();
          }

          for (var i in data.data.data.menuList) {
            if (code) {

              if (data.data.data.menuList[i].com_code == code) {
                that.curMenuListIndex = i;
                that.type_code = data.data.data.menuList[i].com_code;
                that.areaSortResult = data.data.data.menuList[i].hotspotList;
                that.loadMsg = "全部加载完毕";
                that.is_aggregate = data.data.data.menuList[i].is_aggregate;
                if (that.is_aggregate == 1) {

                  that.setAggregateMarker(data.data.data.menuList[i].areaList);
                } else {

                  that.setUnaggregateMarker(data.data.data.menuList[i].hotspotList, data.data.data.menuList[i].com_code, data.data.data.menuList[i].point_icon, data.data.data.menuList[i].point_picth_icon);
                }
                break;
              }
            } else {

              if (data.data.data.menuList[i].visible == 2) {
                that.curMenuListIndex = i;
                that.type_code = data.data.data.menuList[i].com_code;
                that.areaSortResult = data.data.data.menuList[i].hotspotList;

                that.loadMsg = "全部加载完毕";
                that.is_aggregate = data.data.data.menuList[i].is_aggregate;
                if (that.is_aggregate == 1) {

                  that.setAggregateMarker(data.data.data.menuList[i].areaList);
                } else {

                  that.setUnaggregateMarker(data.data.data.menuList[i].hotspotList, data.data.data.menuList[i].com_code, data.data.data.menuList[i].point_icon, data.data.data.menuList[i].point_picth_icon);
                }
                break;
              }
            }
          }

          for (var _i in data.data.data.iconList) {
            if (data.data.data.iconList[_i].com_id == 6) {

              that.tollitImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
            } else if (data.data.data.iconList[_i].com_id == 7) {

              that.locationImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
              that.locationImgActive = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].picth_icon;
            } else if (data.data.data.iconList[_i].com_id == 8) {

              that.searchImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
            } else if (data.data.data.iconList[_i].com_id == 9) {

              that.viewImgDefault = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].icon;
              that.viewImgActive = that.GLOBAL.DOMAIN_URL + data.data.data.iconList[_i].picth_icon;
            }
          }
        }
      });
    },
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: that.scenicZoom, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      that.isLocation = true;

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      AMap.event.addListener(that.mapObj, "zoomend", function () {
        var lnglat = [that.mapObj.getCenter().lng, that.mapObj.getCenter().lat];
        var zoom = that.mapObj.getZoom();
        if (zoom > 13) {
          that.leLayer.setTileUrl("https://tiles.worldmaipu.com/all/[z]/[x]_[y].png");
        } else {
          that.leLayer.setTileUrl("https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png");
        }

        that.geocoder.getAddress(lnglat, function (status, result) {

          if (status === "complete" && result.info === "OK") {

            var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);

            if (result.regeocode.addressComponent.adcode.substring(0, 2) == "33") {
              if (zoom < 9) {} else if (zoom < 19) {

                console.log("市级及以下");
                if (cityCode == that.adCode) {

                  console.log("没有切换市级 切换不同层级的点");
                  that.mapChangeMarkers();
                } else {}
              }
            }
          }
        });
      });

      AMap.event.addListener(that.mapObj, "moveend", function () {
        console.log("move......................");

        that.mapMoveEnd();
      });

      AMap.event.addListener(that.mapObj, "click", function () {
        console.log("点击地图");
        that.mapHeight = that.screenH - that.sliderBasicHeight + "px";
        that.sliderTop = that.screenH - that.sliderBasicHeight + "px";
        that.isPopUp = false;
      });

      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 180)
        }));
      });

      that.mapObj.plugin("AMap.Geocoder", function () {
        that.geocoder = new AMap.Geocoder({

          city: "浙江省",
          extensions: "base"
        });
      });
    },
    mapMoveEnd: function mapMoveEnd() {
      var that = this;
      var lnglat = [this.mapObj.getCenter().lng, this.mapObj.getCenter().lat];
      var zoom = this.mapObj.getZoom();
      console.log("当前层级：" + zoom);
      this.geocoder.getAddress(lnglat, function (status, result) {

        if (status === "complete" && result.info === "OK") {

          console.log(result);

          var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);
          console.log(cityCode + "..." + that.adCode);

          if (result.regeocode.addressComponent.adcode.substring(0, 2) == "33") {
            console.log("在浙江省内");

            console.log("市级adcode：" + cityCode);
            if (zoom < 9) {
              that.mapObj.remove(that.cityPolygons);
              that.citycode = null;

              console.log("省级5-8");
              if (that.adCode == 3300) {
                return;
              } else {
                that.hid = 15847;
                that.adCode = 3300;
                that.getAreaData(that.adCode, that.hid);
              }
            } else if (zoom < 19) {
              if (that.citycode == result.regeocode.addressComponent.citycode) {} else {
                console.log("画区域边界");
                that.citycode = result.regeocode.addressComponent.citycode;
                AMap.plugin("AMap.DistrictSearch", function () {

                  var district = new AMap.DistrictSearch({

                    extensions: "all",

                    level: "city"
                  });

                  district.search(that.citycode, function (status, result) {

                    var bounds = result.districtList[0].boundaries;
                    that.mapObj.remove(that.cityPolygons);
                    that.cityPolygons = [];
                    if (bounds) {
                      for (var i = 0, l = bounds.length; i < l; i++) {

                        var polygon = new AMap.Polygon({
                          map: that.mapObj,
                          strokeWeight: 2,
                          path: bounds[i],
                          fillOpacity: 0,

                          strokeColor: "#48636e"
                        });
                        that.cityPolygons.push(polygon);
                      }
                    }
                  });
                });
              }

              console.log("市级及以下");
              if (cityCode == that.adCode) {

                console.log("没有切换市级");
              } else {
                that.adCode = cityCode;
                console.log("切换市级");

                that.getAreaData(that.adCode, null, that.type_code);
              }
            }
          } else {
            that.mapObj.remove(that.cityPolygons);
            that.citycode = null;
            console.log("不在浙江省内");
            console.log("市级adcode：" + cityCode);
            if (zoom < 9) {

              console.log("省级5-8");
              if (that.adCode == 3300) {
                return;
              } else {
                that.hid = 15847;
                that.adCode = 3300;
                that.getAreaData(that.adCode, that.hid);
              }
            }
          }
        }
      });
    },
    down: function down() {
      console.log("down..................");
      this.flags = true;
      var touch = void 0;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = moveDiv.offsetLeft;
      this.dy = moveDiv.offsetTop;
    },
    move: function move(e) {
      console.log("move..................");
      this.isMoved = true;
      var sliderResult = document.getElementById("slider_result");
      var sliderTags = document.getElementById("sliderTags");

      if (this.flags) {
        var touch = void 0;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }

        if (sliderResult.querySelector("." + e.target.className)) {

          console.log("在滚动区域滑");
          if (this.isContentTop == true) {

            if (touch.clientY - this.position.y > 0) {} else {

              return;
            }
          } else if (this.isContentBottom == true) {
            if (touch.clientY - this.position.y < 0) {} else {
              return;
            }
          } else {
            return;
          }
        } else if (sliderTags.querySelector("." + e.target.className)) {} else {
          e.preventDefault();
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;

        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;

        if (Math.abs(this.ny) > Math.abs(this.nx)) {

          e.preventDefault();
          if (this.yPum < 0) {
            this.sliderTop = 0 + "px";
          } else {
            this.sliderTop = this.yPum + "px";
          }
        } else {}

        document.addEventListener("touchmove", function (event) {

          event.stopPropagation();
        }, false);
      }
    },
    end: function end() {
      console.log("end..................");

      if (!this.isMoved) {
        return;
      }

      this.flags = false;
      this.isMoved = false;

      var upPercent = (1 - this.yPum / this.screenH).toFixed(2);

      if (upPercent < 0.25) {
        console.log("0---0.25");
        this.mapHeight = this.screenH - this.sliderBasicHeight + "px";
        this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
        this.isPopUp = false;
      } else if (upPercent < 0.75) {

        console.log("0.25---0.75");
        this.mapHeight = this.screenH / 2 + "px";
        this.sliderTop = this.screenH / 2 + "px";
        this.isPopUp = true;
      } else if (upPercent < 2) {
        this.mapHeight = 0 + "px";
        this.sliderTop = 0 + "px";
        this.isPopUp = true;
      }
    },
    sortResultScroll: function sortResultScroll(e) {
      e.stopPropagation();

      var scrollTop = document.getElementById("slider_result").scrollTop;
      var clientHeight = document.getElementById("slider_result").clientHeight;
      var scrollHeight = document.getElementById("slider_result").scrollHeight;
      if (clientHeight == scrollHeight) {

        this.isContentTop = true;
        this.isContentBottom = true;
      } else {

        if (scrollTop == 0) {
          console.log("滚动区在顶部");
          this.isContentTop = true;
        } else if (scrollTop + clientHeight == scrollHeight) {
          console.log("滚动区在底部");
          this.isContentBottom = true;
        } else {
          this.isContentTop = false;
          this.isContentBottom = false;
        }
      }
    },
    changeMenu: function changeMenu(i, code, type, url) {
      console.log("切换menu");

      if (type == 3) {
        window.location.href = url;
      } else {

        if (code != this.type_code) {
          console.log("changeMenu");
          this.type_code = code;
          this.curMenuListIndex = i;
          this.curTagListIndex = 0;
          this.is_aggregate = this.areaData.menuList[this.curMenuListIndex].is_aggregate;
          this.tag_id = -1;
          this.area_id = -1;

          this.changeSort(true);
        }

        if (this.isPopUp) {
          return;
        } else {
          this.isPopUp == true;
          this.sliderTop = "50%";
          this.mapHeight = this.screenH / 2 + "px";
        }
      }
    },
    changeCity: function changeCity(i, id, lat, lng) {
      console.log("切换区域");
      console.log(i + "---" + id);
      if (this.area_id == id) {
        return;
      } else {

        if (lat != 0 && lng != 0) {
          this.mapObj.setCenter([lng, lat]);
        }
        this.area_id = id;
        console.log(this.area_id);

        if (this.is_aggregate == 1) {
          this.changeSort(false);
        } else {
          this.changeSort(true);
        }
      }
    },
    changeTag: function changeTag(i, id) {
      console.log("切换tag");

      if (id == this.tag_id) {
        return;
      } else {

        this.curTagListIndex = i;
        this.tag_id = id;

        this.changeSort(true);
      }
    },
    getAreaSortResult: function getAreaSortResult(needChangeMaker) {
      var that = this;
      this.loadMsg = "加载中...";
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getDeatilDatas.action",
        params: {

          hid: that.hid, //景区id
          type_code: that.type_code, //父区域滑块总分类code
          area_id: that.area_id, //子区域id
          tag_id: that.tag_id, //子区域中左侧筛选id


          is_aggregate: that.is_aggregate, //是否聚合展示
          lat: sessionStorage.getItem("lat"),
          lng: sessionStorage.getItem("lng")
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);

          that.areaSortResult = data.data.data.detailList.hotspotList;

          if (that.areaSortResult == null || that.areaSortResult.length == 0) {
            that.loadMsg = "暂无数据";
          } else {
            that.loadMsg = "全部加载完成";
          }
          if (needChangeMaker) {
            if (that.is_aggregate == 1) {

              that.setAggregateMarker(data.data.data.detailList.areaList);
            } else {

              that.setUnaggregateMarker(data.data.data.detailList.hotspotList, data.data.data.detailList.com_code, data.data.data.detailList.point_icon, data.data.data.detailList.point_picth_icon);
            }
          }
        }
      });
    },
    changeSort: function changeSort(needChangeMaker) {

      this.areaSortResult = [];
      this.getAreaSortResult(needChangeMaker);
    },
    setAggregateMarker: function setAggregateMarker(pointArr) {
      var that = this;

      this.mapObj.remove(this.curMapMarkers);
      this.curMapMarkers = [];
      for (var i in pointArr) {
        var marker = new AMap.Marker({
          map: this.mapObj,
          content: "<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" + pointArr[i].name + "</span><i>" + pointArr[i].counts + "</i>" + "</span></div>",
          position: new AMap.LngLat(pointArr[i].longitude_gcj, pointArr[i].latitude_gcj),

          offset: new AMap.Pixel(-10, -32), //中心点


          extData: {
            hotspot_id: pointArr[i].hotspot_id
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);
          that.hid = extData.hotspot_id;

          that.mapObj.setZoomAndCenter(9, position);
        });
        this.mapObj.remove(marker);

        this.curMapMarkers.push(marker);
      }
      this.mapObj.add(this.curMapMarkers);
    },
    setUnaggregateMarker: function setUnaggregateMarker(pointArr, code, defaultBg, acitveBg) {
      var that = this;

      that.resetCurProvinceMarkerArr();

      for (var i in pointArr) {

        var level = pointArr[i].level;
        var marker = new AMap.Marker({

          content: "<div class='province-poi'><img src='" + that.GLOBAL.DOMAIN_URL + defaultBg + "' class='ua_poi' id='ua_marker" + i + "'><span class='ua_poi_name'>" + pointArr[i].name + "</span></div>",
          position: new AMap.LngLat(pointArr[i].longitude_gcj, pointArr[i].latitude_gcj),
          offset: new AMap.Pixel(-16, -36),

          extData: {
            hotspot_id: pointArr[i].id,
            com_code: code,
            default_bg: defaultBg,
            active_bg: acitveBg,
            id_index: i,
            poiData: pointArr[i],
            level: level
          }
        });
        for (var z = 0; z < that.curProvinceMarkerArr.length; z++) {

          var startZoom = level - that.mapMinZoom;
          if (startZoom <= z) {
            that.curProvinceMarkerArr[z].push(marker);
          }
        }
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);
          that.mapObj.setCenter(position);

          if (extData.poiData.com_code == 20) {

            that.get({
              url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
              params: {
                id: extData.hotspot_id //景区id
              },
              isShowLoading: false,
              success: function success(data) {
                console.log(data.data);

                that.details.is_guide = extData.poiData.is_guide;
                that.details.id = extData.hotspot_id;
                that.details.imgList = data.data.data.imgs;
                that.details.title = data.data.data.homeStays.homestay_name;
                that.details.address = data.data.data.homeStays.address;
                that.details.des = data.data.data.homeStays.characters;
                that.details.mobile = data.data.data.homeStays.mobile;
                that.details.lat = data.data.data.homeStays.latitude;
                that.details.lng = data.data.data.homeStays.longitude;
                that.isDetailPopShow = true;
              }
            });
          } else {

            var data = {
              address: extData.poiData.address,
              audio: extData.poiData.audio,
              com_code: extData.poiData.com_code,
              id: extData.hotspot_id,
              is_guide: extData.poiData.is_guide,
              latitude_gcj: extData.poiData.latitude_gcj,
              longitude_gcj: extData.poiData.longitude_gcj,
              name: extData.poiData.name,
              thumb_img: extData.poiData.thumb_img
            };
            that.scenicPopData = data;
            that.isScenicPopShow = true;
          }
        });
      }

      that.mapChangeMarkers();
    },
    resetCurProvinceMarkerArr: function resetCurProvinceMarkerArr() {
      this.curProvinceMarkerArr = [];
      for (var i = this.mapMinZoom; i < this.mapMaxZoom + 1; i++) {

        this.curProvinceMarkerArr.push([]);
      }
    },
    mapChangeMarkers: function mapChangeMarkers() {
      console.log("市级切换层级 的点位");
      var zoom = this.mapObj.getZoom();
      this.mapObj.remove(this.curMapMarkers);
      this.curMapMarkers = [];
      this.curMapMarkers = this.curProvinceMarkerArr[zoom - this.mapMinZoom];
      console.log("加载第" + zoom + "级的点");
      this.mapObj.add(this.curMapMarkers);
    },
    jumpTo: function jumpTo(obj) {
      var that = this;
      if (obj.com_code == 20) {

        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
          params: {
            id: obj.id //景区id
          },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data);
            var details = {};

            details.is_guide = obj.is_guide;
            details.id = obj.id;
            details.imgList = data.data.data.imgs;
            details.title = data.data.data.homeStays.homestay_name;
            details.address = data.data.data.homeStays.address;
            details.des = data.data.data.homeStays.characters;
            details.mobile = data.data.data.homeStays.mobile;
            details.lat = data.data.data.homeStays.latitude;
            details.lng = data.data.data.homeStays.longitude;

            that.details = details;
            that.isDetailPopShow = true;
          }
        });
      } else {

        var data = obj;
        console.log(obj);
        that.scenicPopData = data;
        that.isScenicPopShow = true;
      }
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      if (val == false) {
        this.details = {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false,
          id: ""
        }; //清空详情组件的details props
      }
    },
    changeScenicPop: function changeScenicPop(val) {
      this.isScenicPopShow = val;
    },
    getScenicDetailFromScenicPop: function getScenicDetailFromScenicPop(val) {
      var that = this;

      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: val.id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = val.is_guide;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          for (var i in data.data.data.imgList) {
            details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
        }
      });
      this.isScenicPopShow = false;
      this.isDetailPopShow = true;
    }
  },

  created: function created() {
    this.getAreaData(null, this.hid);
  },
  mounted: function mounted() {
    console.log(this.$route.query);

    this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
    this.mapHeight = this.screenH - this.sliderBasicHeight + "px";
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fb4a4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapHeight != '0px'),expression:"mapHeight != '0px'"}],staticClass:"mapBox",style:({ height: _vm.mapHeight })},[_c('div',{staticClass:"container",attrs:{"id":"container"}}),_vm._v(" "),_c('div',{attrs:{"id":"paint"}},[_c('leLayer',{attrs:{"isLelayerShow":_vm.isLelayerShow,"leLayer":_vm.leLayer,"activeImg":_vm.viewImgActive,"defaultImg":_vm.viewImgDefault,"mapObj":_vm.mapObj}})],1),_vm._v(" "),_c('getLocation',{attrs:{"isLocation":_vm.isLocation,"scenicBound":_vm.scenicBound,"mapObj":_vm.mapObj,"id":"location","activeImg":_vm.locationImgActive,"defaultImg":_vm.locationImgDefault}}),_vm._v(" "),_c('router-link',{attrs:{"id":"toilet","to":"toilet"}},[_c('img',{attrs:{"src":_vm.tollitImgDefault,"alt":""}})]),_vm._v(" "),_c('router-link',{attrs:{"id":"search","to":"search"}},[_c('img',{attrs:{"src":_vm.searchImgDefault,"alt":""}})])],1),_vm._v(" "),(_vm.areaData)?_c('div',{staticClass:"slider",style:({ top: _vm.sliderTop, height: _vm.sliderHeight }),attrs:{"id":"moveDiv"}},[_c('div',{staticClass:"slider-tags",attrs:{"id":"sliderTags"},on:{"touchstart":_vm.down,"mousedown":_vm.down,"touchmove":_vm.move,"mousemove":_vm.move,"touchend":_vm.end,"mouseup":_vm.end}},[_c('div',{staticClass:"drag-bar"}),_vm._v(" "),_c('div',{staticClass:"slider-tags-wrap"},_vm._l((_vm.areaData.menuList),function(item,index){return _c('div',{key:item.id,class:['slider-tag', _vm.type_code == item.com_code ? 'on' : ''],on:{"click":function($event){return _vm.changeMenu(index, item.com_code, item.com_type, item.url)}}},[_c('i',{staticClass:"slider-tag-icon",style:({
              'background-image':
                _vm.type_code == item.com_code
                  ? 'url(' + _vm.GLOBAL.DOMAIN_URL + item.picth_icon + ')'
                  : 'url(' + _vm.GLOBAL.DOMAIN_URL + item.icon + ')',
            })}),_vm._v(" "),_c('span',{staticClass:"slider-tag-name ellipsis-1"},[_vm._v(_vm._s(item.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"slider-content"},[_c('div',{staticClass:"slider-types"},_vm._l((_vm.areaData.areaList),function(item,index){return _c('div',{key:index,class:['slider-type', _vm.area_id == item.id ? 'active' : ''],on:{"click":function($event){return _vm.changeCity(index, item.id, item.latitude_gcj, item.longitude_gcj)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticClass:"slider-type-content"},[_c('div',{staticClass:"slider-type-tabs vux-1px-r",on:{"touchstart":_vm.down,"mousedown":_vm.down,"touchmove":_vm.move,"mousemove":_vm.move,"touchend":_vm.end,"mouseup":_vm.end}},_vm._l((_vm.areaData.menuList[_vm.curMenuListIndex]
              .tagList),function(item,index){return _c('div',{key:index,class:['slider-type-tab', _vm.curTagListIndex == index ? 'on' : ''],on:{"click":function($event){return _vm.changeTag(index, item.id)}}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0),_vm._v(" "),_c('div',{ref:"scrollBox",staticClass:"slider-result",attrs:{"id":"slider_result"},on:{"scroll":_vm.sortResultScroll}},[_vm._l((_vm.areaSortResult),function(item,index){return _c('div',{key:index,staticClass:"slider-result-item",on:{"click":function($event){return _vm.jumpTo(item)}}},[_c('x-img',{staticClass:"result-item-bg",attrs:{"default-src":_vm.xImgDftSrc,"offset":600,"container":"#slider_result","src":item.thumb_img == null || item.thumb_img == ''
                  ? _vm.xImgNoImg
                  : item.thumb_img.indexOf('http') != -1
                  ? item.thumb_img
                  : _vm.GLOBAL.DOMAIN_URL + item.thumb_img}}),_vm._v(" "),_c('div',{staticClass:"result-item-right"},[_c('div',{staticClass:"result-item-name ellipsis-1"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.tags)?_c('div',{staticClass:"result-item-tags"},_vm._l((item.tags.split(',')),function(data,i){return _c('span',{key:i,staticClass:"result-item-tag",style:('color:#' + item.colors.split(',')[i])},[(
                      item.icons != null && item.icons.split(',')[i] != ''
                    )?_c('img',{staticClass:"result-item-tag-icon",attrs:{"src":_vm.GLOBAL.DOMAIN_URL + item.icons.split(',')[i],"alt":""}}):_vm._e(),_vm._v("\n                  "+_vm._s(data)+"\n                ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"result-item-add"},[_c('i',{staticClass:"result-item-add-icon"}),_vm._v(" "),_c('span',{staticClass:"result-item-address ellipsis-1"},[_vm._v(_vm._s(item.address))])])])],1)}),_vm._v(" "),_c('load-more',{attrs:{"show-loading":_vm.loadMsg == '加载中...',"tip":_vm.loadMsg,"background-color":"#fbf9fe"}})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"top","show-mask":false},model:{value:(_vm.shopPopup),callback:function ($$v) {_vm.shopPopup=$$v},expression:"shopPopup"}},[_c('div',{staticClass:"position-vertical-demo"},[_vm._v("欢迎进入 "+_vm._s(_vm.scenicName))])])],1),_vm._v(" "),_c('detailPop',{attrs:{"isDetailPopShow":_vm.isDetailPopShow,"details":_vm.details},on:{"changeDetailShow":_vm.changeDetailPop}}),_vm._v(" "),_c('scenicPop',{attrs:{"isScenicPopShow":_vm.isScenicPopShow,"scenicPopData":_vm.scenicPopData},on:{"changeScenicPopShow":_vm.changeScenicPop,"getScenicDetail":_vm.getScenicDetailFromScenicPop}})],1)}
var Index_staticRenderFns = []
var Index_esExports = { render: Index_render, staticRenderFns: Index_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_Index = (Index_esExports);
// CONCATENATED MODULE: ./src/pages/Index.vue
function Index_injectStyle (ssrContext) {
  __webpack_require__("xcCl")
  __webpack_require__("hGGl")
}
var Index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = Index_injectStyle
/* scopeId */
var Index___vue_scopeId__ = "data-v-53fb4a4b"
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null
var Index_Component = Index_normalizeComponent(
  pages_Index,
  selectortype_template_index_0_src_pages_Index,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var src_pages_Index = (Index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/touch.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var touch = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      flags: false,
      screenH: document.documentElement.clientHeight, //屏幕高度
      sliderHeight: null, //滑块总高度
      sliderTop: null,
      sliderBasicHeight: 70, //初始bottom值
      mapHeight: "100%",
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: ""
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 实现移动端拖拽
    down: function down() {
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = moveDiv.offsetLeft;
      this.dy = moveDiv.offsetTop;
    },
    move: function move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        // moveDiv.style.left = this.xPum + "px";
        // moveDiv.style.top = this.yPum + "px";
        this.sliderTop = this.yPum + "px"; //滑块top值改变

        //阻止页面的滑动默认事件
        document.addEventListener("touchmove", function (event) {
          // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
          // event.preventDefault(); //jq 阻止冒泡事件
          event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
        }, false);
      }
    },

    //鼠标释放时候的函数
    end: function end() {
      this.flags = false;
      this.mapHeight = this.yPum + "px"; //地图高度最终改变
      console.log(this.mapHeight);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.sliderHeight = document.getElementsByClassName("slider")[0].clientHeight;
    this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/touch.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var pages_touch = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      flags: false,
      screenH: document.documentElement.clientHeight, //屏幕高度
      sliderHeight: null, //滑块总高度
      sliderTop: null,
      sliderBasicHeight: 70, //初始bottom值
      mapHeight: "100%",
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: ""
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 实现移动端拖拽
    down: function down() {
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = moveDiv.offsetLeft;
      this.dy = moveDiv.offsetTop;
    },
    move: function move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        // moveDiv.style.left = this.xPum + "px";
        // moveDiv.style.top = this.yPum + "px";
        this.sliderTop = this.yPum + "px"; //滑块top值改变

        //阻止页面的滑动默认事件
        document.addEventListener("touchmove", function (event) {
          // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
          // event.preventDefault(); //jq 阻止冒泡事件
          event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
        }, false);
      }
    },

    //鼠标释放时候的函数
    end: function end() {
      this.flags = false;
      this.mapHeight = this.yPum + "px"; //地图高度最终改变
      console.log(this.mapHeight);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.sliderHeight = document.getElementsByClassName("slider")[0].clientHeight;
    this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1261c15f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/touch.vue
var touch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"container",style:({'height':_vm.mapHeight})}),_vm._v(" "),_c('div',{staticClass:"xuanfu",style:({'top':_vm.sliderTop}),attrs:{"id":"moveDiv"},on:{"mousedown":_vm.down,"touchstart":_vm.down,"mousemove":_vm.move,"touchmove":_vm.move,"mouseup":_vm.end,"touchend":_vm.end}})])}
var touch_staticRenderFns = []
var touch_esExports = { render: touch_render, staticRenderFns: touch_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_touch = (touch_esExports);
// CONCATENATED MODULE: ./src/pages/touch.vue
function touch_injectStyle (ssrContext) {
  __webpack_require__("lJuI")
}
var touch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var touch___vue_template_functional__ = false
/* styles */
var touch___vue_styles__ = touch_injectStyle
/* scopeId */
var touch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var touch___vue_module_identifier__ = null
var touch_Component = touch_normalizeComponent(
  pages_touch,
  selectortype_template_index_0_src_pages_touch,
  touch___vue_template_functional__,
  touch___vue_styles__,
  touch___vue_scopeId__,
  touch___vue_module_identifier__
)

/* harmony default export */ var src_pages_touch = (touch_Component.exports);

// EXTERNAL MODULE: external "AMap"
var external__AMap_ = __webpack_require__("+aT9");
var external__AMap__default = /*#__PURE__*/__webpack_require__.n(external__AMap_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/toilet.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var toilet = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      // 地图start
      mapObj: null, //地图实例
      leLayer: null, //瓦片实例
      mapMaxZoom: 19, //地图最大层级
      mapMinZoom: 13, //地图最小层级
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      toiletPois: null, //厕所点集合
      walk: null, //线路规划
      walkIdx: -1 //线路规划中的poi点的下标
      // 地图end
    };
  },

  //监听属性 类似于data概念
  computed: {
    // toiletPois: function() {}
  },
  //监控data中的数据变化
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // toiletPois: function(newV, oldV) {
    //     console.log('变化咯。。。。。。。。。')
    // }
  },
  //方法集合
  methods: {
    //   地图初始化
    initMap: function initMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new external__AMap__default.a.Map("container", {
        view: new external__AMap__default.a.View2D({
          //创建地图二维视口
          // center: new AMap.LngLat(
          //   sessionStorage.getItem("lng"),
          //   sessionStorage.getItem("lat")
          // ),
          zoom: 16, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 瓦片加载
      that.leLayer = new external__AMap__default.a.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl: "https://daoyou.worldmaipu.com" + "/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]',
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]&hid=',
        zIndex: 2
      });
      //   that.leLayer.setMap(that.mapObj);
      // 缩放组件
      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new external__AMap__default.a.ToolBar({
          position: "RB",
          //locate:true
          liteStyle: true,
          offset: new external__AMap__default.a.Pixel(10, 100)
        }));
      });
      that.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 初始默认持续获取当前定位
      that.watchCurPosition();
    },

    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("on");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        that.clearWatchCurPosition();
        console.log(position);
        var lnglat = new external__AMap__default.a.LngLat(position.lng, position.lat);
        that.mapObj.setCenter(lnglat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        console.log(lnglat);
        if (that.isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.isLocation = true;
          that.locationMarker = new external__AMap__default.a.Marker({
            position: lnglat,
            offset: new external__AMap__default.a.Pixel(-8, -16),
            content: "<div class='curMarker'></div>"
          });
          that.mapObj.add(that.locationMarker);
        }
        that.searchToilet(position.lat, position.lng);
      }
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      // this.mapObj.remove(this.locationMarker);
      // this.isLocation = false;
      // this.locationMarker = null;
    },

    //   搜索厕所poi
    searchToilet: function searchToilet(lat, lng) {
      var that = this;
      that.get({
        url: "https://restapi.amap.com/v3/place/around",
        params: {
          key: "c2526cf60981aa9faf0d2a8bab1b67bc",
          radius: 30000,
          //   city: "杭州",
          //   sortrule: "distance",
          // citylimit: true,
          //   offset: 10,
          //   keywords: "卫生间",
          types: "200300|200301|200302|200303|200304",
          location: lng + "," + lat,
          output: "JSON"
        },
        isShowLoading: true,
        success: function success(res) {
          console.log(res);
          that.toiletPois = res.data.pois;
          // that.$nextTick(function(){
          //   document.getElementById('toiletBox').style.overflowY='auto';
          // })
          that.setToiletPois(that.toiletPois);
        }
      });

      //   that.get({
      //     url:
      //       //   that.domainName + "/api/v1/map_view!GetSingleSecentWebs.action",
      //       that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentInfo.action",
      //     params: { lineId: "4838" },
      //     success: function(data) {
      //       console.log(data);
      //       //   that.mapData = data;
      //       //   that.hid = data.hid;
      //       //   that.getMap(that.mapData);
      //     }
      //   });
      //   that.get({
      //     url:
      //         "http://192.168.1.8:8083/api/v1/map_view!GetSingleSecentWebs.action",
      //     //   that.GLOBAL.BASE_URL + "/api/v1/channel!FindSurvey.action",
      //     // params: { lineId: "4838" },
      //     success: function(data) {
      //       console.log(data);
      //       //   that.mapData = data;
      //       //   that.hid = data.hid;
      //       //   that.getMap(that.mapData);
      //     }
      //   });
      //   this.$http
      //     .get(
      //         "https://restapi.amap.com/v3/place/around"
      //         // '/v3'+"/v3/place/around"

      //         , {
      //       params: {
      //         key: "c2526cf60981aa9faf0d2a8bab1b67bc",
      //         radius: 30000,
      //         //   city: "杭州",
      //         //   sortrule: "distance",
      //         // citylimit: true,
      //         //   offset: 10,
      //         //   keywords: "卫生间",
      //         types: "200300|200301|200302|200303|200304",
      //         location: lng + "," + lat,
      //         output: "JSON"
      //       }
      //     })
      //     .then(({ data }) => {
      //       console.log(data);
      //     });
    },
    setToiletPois: function setToiletPois(arr) {
      var that = this;
      for (var i in arr) {
        var marker = new external__AMap__default.a.Marker({
          map: that.mapObj,
          position: new external__AMap__default.a.LngLat(arr[i].location.split(",")[0], arr[i].location.split(",")[1]),
          offset: new external__AMap__default.a.Pixel(-13.5, -18.5),
          content: "<div class='search-toilet'></div>",
          extData: {
            index: i
          }
        });
        // that.mapObj.add(marker);
        external__AMap__default.a.event.addListener(marker, "click", function (e) {
          that.walkIdx = e.target.getExtData().index;
          var lat = e.target.getPosition().lat;
          var lng = e.target.getPosition().lng;
          external__AMap__default.a.service("AMap.Walking", function () {
            if (that.walk) {
              that.walk.clear();
            }
            that.walk = new external__AMap__default.a.Walking({
              map: that.mapObj
              //用于显示路线指引信息的Div容器的id或Div元素
              //panel: "panel"
            });
            // 根据起终点经纬度规划驾车导航路线
            that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
              // console.log(result);
              if (status === "complete" && result.info === "OK") {
                that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
              }
            });
          });
          console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
          // 规划中的厕所点的对应dom滚动到顶部
          document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
        });
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = '厕所';
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.initMap();
    // this.searchToilet()
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/toilet.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var pages_toilet = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      // 地图start
      mapObj: null, //地图实例
      leLayer: null, //瓦片实例
      mapMaxZoom: 19, //地图最大层级
      mapMinZoom: 13, //地图最小层级
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      toiletPois: null, //厕所点集合
      walk: null, //线路规划
      walkIdx: -1 //线路规划中的poi点的下标
      // 地图end
    };
  },

  //监听属性 类似于data概念
  computed: {
    // toiletPois: function() {}
  },
  //监控data中的数据变化
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // toiletPois: function(newV, oldV) {
    //     console.log('变化咯。。。。。。。。。')
    // }
  },
  //方法集合
  methods: {
    //   地图初始化
    initMap: function initMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new external__AMap__default.a.Map("container", {
        view: new external__AMap__default.a.View2D({
          //创建地图二维视口
          // center: new AMap.LngLat(
          //   sessionStorage.getItem("lng"),
          //   sessionStorage.getItem("lat")
          // ),
          zoom: 16, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 瓦片加载
      that.leLayer = new external__AMap__default.a.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl: "https://daoyou.worldmaipu.com" + "/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]',
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]&hid=',
        zIndex: 2
      });
      //   that.leLayer.setMap(that.mapObj);
      // 缩放组件
      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new external__AMap__default.a.ToolBar({
          position: "RB",
          //locate:true
          liteStyle: true,
          offset: new external__AMap__default.a.Pixel(10, 100)
        }));
      });
      that.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 初始默认持续获取当前定位
      that.watchCurPosition();
    },

    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("on");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        that.clearWatchCurPosition();
        console.log(position);
        var lnglat = new external__AMap__default.a.LngLat(position.lng, position.lat);
        that.mapObj.setCenter(lnglat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        console.log(lnglat);
        if (that.isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.isLocation = true;
          that.locationMarker = new external__AMap__default.a.Marker({
            position: lnglat,
            offset: new external__AMap__default.a.Pixel(-8, -16),
            content: "<div class='curMarker'></div>"
          });
          that.mapObj.add(that.locationMarker);
        }
        that.searchToilet(position.lat, position.lng);
      }
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      // this.mapObj.remove(this.locationMarker);
      // this.isLocation = false;
      // this.locationMarker = null;
    },

    //   搜索厕所poi
    searchToilet: function searchToilet(lat, lng) {
      var that = this;
      that.get({
        url: "https://restapi.amap.com/v3/place/around",
        params: {
          key: "c2526cf60981aa9faf0d2a8bab1b67bc",
          radius: 30000,
          //   city: "杭州",
          //   sortrule: "distance",
          // citylimit: true,
          //   offset: 10,
          //   keywords: "卫生间",
          types: "200300|200301|200302|200303|200304",
          location: lng + "," + lat,
          output: "JSON"
        },
        isShowLoading: true,
        success: function success(res) {
          console.log(res);
          that.toiletPois = res.data.pois;
          // that.$nextTick(function(){
          //   document.getElementById('toiletBox').style.overflowY='auto';
          // })
          that.setToiletPois(that.toiletPois);
        }
      });

      //   that.get({
      //     url:
      //       //   that.domainName + "/api/v1/map_view!GetSingleSecentWebs.action",
      //       that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentInfo.action",
      //     params: { lineId: "4838" },
      //     success: function(data) {
      //       console.log(data);
      //       //   that.mapData = data;
      //       //   that.hid = data.hid;
      //       //   that.getMap(that.mapData);
      //     }
      //   });
      //   that.get({
      //     url:
      //         "http://192.168.1.8:8083/api/v1/map_view!GetSingleSecentWebs.action",
      //     //   that.GLOBAL.BASE_URL + "/api/v1/channel!FindSurvey.action",
      //     // params: { lineId: "4838" },
      //     success: function(data) {
      //       console.log(data);
      //       //   that.mapData = data;
      //       //   that.hid = data.hid;
      //       //   that.getMap(that.mapData);
      //     }
      //   });
      //   this.$http
      //     .get(
      //         "https://restapi.amap.com/v3/place/around"
      //         // '/v3'+"/v3/place/around"

      //         , {
      //       params: {
      //         key: "c2526cf60981aa9faf0d2a8bab1b67bc",
      //         radius: 30000,
      //         //   city: "杭州",
      //         //   sortrule: "distance",
      //         // citylimit: true,
      //         //   offset: 10,
      //         //   keywords: "卫生间",
      //         types: "200300|200301|200302|200303|200304",
      //         location: lng + "," + lat,
      //         output: "JSON"
      //       }
      //     })
      //     .then(({ data }) => {
      //       console.log(data);
      //     });
    },
    setToiletPois: function setToiletPois(arr) {
      var that = this;
      for (var i in arr) {
        var marker = new external__AMap__default.a.Marker({
          map: that.mapObj,
          position: new external__AMap__default.a.LngLat(arr[i].location.split(",")[0], arr[i].location.split(",")[1]),
          offset: new external__AMap__default.a.Pixel(-13.5, -18.5),
          content: "<div class='search-toilet'></div>",
          extData: {
            index: i
          }
        });
        // that.mapObj.add(marker);
        external__AMap__default.a.event.addListener(marker, "click", function (e) {
          that.walkIdx = e.target.getExtData().index;
          var lat = e.target.getPosition().lat;
          var lng = e.target.getPosition().lng;
          external__AMap__default.a.service("AMap.Walking", function () {
            if (that.walk) {
              that.walk.clear();
            }
            that.walk = new external__AMap__default.a.Walking({
              map: that.mapObj
              //用于显示路线指引信息的Div容器的id或Div元素
              //panel: "panel"
            });
            // 根据起终点经纬度规划驾车导航路线
            that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
              // console.log(result);
              if (status === "complete" && result.info === "OK") {
                that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
              }
            });
          });
          console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
          // 规划中的厕所点的对应dom滚动到顶部
          document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
        });
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = '厕所';
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.initMap();
    // this.searchToilet()
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb0b700","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/toilet.vue
var toilet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container",attrs:{"id":"container"}}),_vm._v(" "),_c('div',{staticClass:"toilet-list"},[_c('ul',{staticClass:"toilet-box",attrs:{"id":"toiletBox"}},_vm._l((_vm.toiletPois),function(item,index){return _c('li',{key:item.id,class:['toilet-item','vux-1px-b',_vm.walkIdx==index?'on':''],on:{"click":function($event){_vm.nav(item.name,item.location.split(',')[1],item.location.split(',')[0])}}},[_c('div',{staticClass:"toilet-content"},[_c('div',{staticClass:"toilet-name"},[_vm._v("\n            "+_vm._s(item.name)+"\n            "),(_vm.walkIdx==index)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("（步行规划线路展示中）")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"toilet-dis-add"},[_c('span',{staticClass:"toilet-dis"},[_vm._v(_vm._s(item.distance)+"米")]),_vm._v(" "),(item.address.length!=0)?_c('span',{staticClass:"toilet-add ellipsis-1"},[_vm._v(_vm._s(item.address))]):_vm._e()])]),_vm._v(" "),_vm._m(0,true)])}),0)])])}
var toilet_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toilet-nav"},[_c('i',{}),_vm._v(" "),_c('span',[_vm._v("导航")])])}]
var toilet_esExports = { render: toilet_render, staticRenderFns: toilet_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_toilet = (toilet_esExports);
// CONCATENATED MODULE: ./src/pages/toilet.vue
function toilet_injectStyle (ssrContext) {
  __webpack_require__("itVq")
  __webpack_require__("6a0+")
}
var toilet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toilet___vue_template_functional__ = false
/* styles */
var toilet___vue_styles__ = toilet_injectStyle
/* scopeId */
var toilet___vue_scopeId__ = "data-v-1bb0b700"
/* moduleIdentifier (server only) */
var toilet___vue_module_identifier__ = null
var toilet_Component = toilet_normalizeComponent(
  pages_toilet,
  selectortype_template_index_0_src_pages_toilet,
  toilet___vue_template_functional__,
  toilet___vue_styles__,
  toilet___vue_scopeId__,
  toilet___vue_module_identifier__
)

/* harmony default export */ var src_pages_toilet = (toilet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 详情弹窗组件

/* harmony default export */ var search = ({
  //import引入的组件需要注入到对象中才能使用
  components: { detailPop: src_components_detailPop },
  data: function data() {
    //这里存放数据
    return {
      keyWord: "", //搜索关键词
      historyWords: [], //搜索历史
      hotKeywords: [],
      isShowResult: false,
      result: [], //搜索结果集

      // 详情弹窗
      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: "" //详情弹窗组件的porps
      } };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    inputFun: function inputFun() {
      console.log(this.commonFun.trim(this.keyWord));
      if (this.commonFun.trim(this.keyWord) == "") {
        this.isShowResult = false;
      }
    },
    search: function search(word) {
      this.keyWord = word;
      this.getResult();
    },

    // 搜索获取结果
    getResult: function getResult() {
      var that = this;
      console.log(that.keyWord);
      // 判断空字符串
      if (that.commonFun.trim(that.keyWord) == "") {
        console.log("空字符串");
        return;
      }
      var historyWords = JSON.parse(localStorage.getItem("historyWords"));
      console.log(historyWords);
      if (historyWords == null) {
        // 没有本地缓存
        historyWords = [that.keyWord];
        localStorage.setItem("historyWords", stringify_default()([that.keyWord]));
      } else {
        // 有本地缓存
        // 先判断是否有历史相同缓存
        var isHave = false; //是否历史记录中存在该记录
        var idx = void 0; //记录中的下标
        for (var i in historyWords) {
          if (that.commonFun.trim(historyWords[i]) == that.keyWord) {
            isHave = true;
            idx = i;
            break;
          } else {
            isHave = false;
          }
        }
        if (isHave == true) {
          console.log(idx);
          var historyItem = historyWords[idx];
          historyWords.splice(idx, 1);
          historyWords.unshift(historyItem);
        } else {
          historyWords.unshift(that.keyWord);
        }
        localStorage.setItem("historyWords", stringify_default()(historyWords));
      }
      this.historyWords = historyWords;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!Search.action",
        params: { keyword: that.keyWord },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          var result = data.data.data.searchs;
          for (var _i in result) {
            switch (parseInt(result[_i].type)) {
              case 1:
                result[_i].typeName = "景区";
                break;
              case 2:
                result[_i].typeName = "风情小镇";
                break;
              case 3:
                result[_i].typeName = "乡村民宿";
                break;
              case 7:
                result[_i].typeName = "重要景区村";
                break;
              case 8:
                result[_i].typeName = "文化场馆";
                break;
            }
          }
          that.result = result;
          that.isShowResult = true;
        }
      });
    },

    // 获取热门搜索
    getHot: function getHot() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!GetKeyWords.action",
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);

          that.hotKeywords = data.data.data.keyWords;
        }
      });
    },

    // 搜索结果点击
    resultFun: function resultFun(type, id, isGuide) {
      var that = this;
      console.log("type===" + type + "  id===" + id);

      if (type == 3) {
        // 名宿 跳详情弹窗
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
          params: {
            id: id //景区id
          },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data);
            var details = {};
            details.is_guide = false;
            details.id = id;
            details.imgList = data.data.data.imgs;
            details.title = data.data.data.homeStays.homestay_name;
            details.address = data.data.data.homeStays.address;
            details.des = data.data.data.homeStays.characters;
            details.mobile = data.data.data.homeStays.mobile;
            details.lat = data.data.data.homeStays.latitude;
            details.lng = data.data.data.homeStays.longitude;

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
      } else {
        // 除民宿外的所有类别
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
          params: { hid: id },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data.data);
            var details = {};
            details.is_guide = isGuide;
            details.id = data.data.data.hotspot.id;
            details.imgList = [];
            for (var i in data.data.data.imgList) {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
            }
            // details.imgList = data.data.data.imgs;
            details.title = data.data.data.hotspot.name;
            details.address = data.data.data.hotspot.address;
            details.des = data.data.data.hotspot.description;
            details.mobile = "";
            details.lat = data.data.data.hotspot.latitudeGCJ + "";
            details.lng = data.data.data.hotspot.longitudeGCJ + "";
            if (data.data.data.hotspot.audio != null) {
              details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
            }

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
        // if (isGuide) {
        //   // 有导览
        //   this.$router.push({
        //     path: "/map",
        //     name: "map",
        //     query: { hid: id }
        //   });
        // } else {
        // }
      }
    },

    // 监听detail组件是否展示组件的事件
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      this.details = {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      }; //清空详情组件的details props
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = "搜索";
    this.getHot();
    this.historyWords = JSON.parse(localStorage.getItem("historyWords"));
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 详情弹窗组件

/* harmony default export */ var pages_search = ({
  //import引入的组件需要注入到对象中才能使用
  components: { detailPop: src_components_detailPop },
  data: function data() {
    //这里存放数据
    return {
      keyWord: "", //搜索关键词
      historyWords: [], //搜索历史
      hotKeywords: [],
      isShowResult: false,
      result: [], //搜索结果集

      // 详情弹窗
      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: "" //详情弹窗组件的porps
      } };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    inputFun: function inputFun() {
      console.log(this.commonFun.trim(this.keyWord));
      if (this.commonFun.trim(this.keyWord) == "") {
        this.isShowResult = false;
      }
    },
    search: function search(word) {
      this.keyWord = word;
      this.getResult();
    },

    // 搜索获取结果
    getResult: function getResult() {
      var that = this;
      console.log(that.keyWord);
      // 判断空字符串
      if (that.commonFun.trim(that.keyWord) == "") {
        console.log("空字符串");
        return;
      }
      var historyWords = JSON.parse(localStorage.getItem("historyWords"));
      console.log(historyWords);
      if (historyWords == null) {
        // 没有本地缓存
        historyWords = [that.keyWord];
        localStorage.setItem("historyWords", stringify_default()([that.keyWord]));
      } else {
        // 有本地缓存
        // 先判断是否有历史相同缓存
        var isHave = false; //是否历史记录中存在该记录
        var idx = void 0; //记录中的下标
        for (var i in historyWords) {
          if (that.commonFun.trim(historyWords[i]) == that.keyWord) {
            isHave = true;
            idx = i;
            break;
          } else {
            isHave = false;
          }
        }
        if (isHave == true) {
          console.log(idx);
          var historyItem = historyWords[idx];
          historyWords.splice(idx, 1);
          historyWords.unshift(historyItem);
        } else {
          historyWords.unshift(that.keyWord);
        }
        localStorage.setItem("historyWords", stringify_default()(historyWords));
      }
      this.historyWords = historyWords;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!Search.action",
        params: { keyword: that.keyWord },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          var result = data.data.data.searchs;
          for (var _i in result) {
            switch (parseInt(result[_i].type)) {
              case 1:
                result[_i].typeName = "景区";
                break;
              case 2:
                result[_i].typeName = "风情小镇";
                break;
              case 3:
                result[_i].typeName = "乡村民宿";
                break;
              case 7:
                result[_i].typeName = "重要景区村";
                break;
              case 8:
                result[_i].typeName = "文化场馆";
                break;
            }
          }
          that.result = result;
          that.isShowResult = true;
        }
      });
    },

    // 获取热门搜索
    getHot: function getHot() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!GetKeyWords.action",
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);

          that.hotKeywords = data.data.data.keyWords;
        }
      });
    },

    // 搜索结果点击
    resultFun: function resultFun(type, id, isGuide) {
      var that = this;
      console.log("type===" + type + "  id===" + id);

      if (type == 3) {
        // 名宿 跳详情弹窗
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
          params: {
            id: id //景区id
          },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data);
            var details = {};
            details.is_guide = false;
            details.id = id;
            details.imgList = data.data.data.imgs;
            details.title = data.data.data.homeStays.homestay_name;
            details.address = data.data.data.homeStays.address;
            details.des = data.data.data.homeStays.characters;
            details.mobile = data.data.data.homeStays.mobile;
            details.lat = data.data.data.homeStays.latitude;
            details.lng = data.data.data.homeStays.longitude;

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
      } else {
        // 除民宿外的所有类别
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
          params: { hid: id },
          isShowLoading: false,
          success: function success(data) {
            console.log(data.data.data);
            var details = {};
            details.is_guide = isGuide;
            details.id = data.data.data.hotspot.id;
            details.imgList = [];
            for (var i in data.data.data.imgList) {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
            }
            // details.imgList = data.data.data.imgs;
            details.title = data.data.data.hotspot.name;
            details.address = data.data.data.hotspot.address;
            details.des = data.data.data.hotspot.description;
            details.mobile = "";
            details.lat = data.data.data.hotspot.latitudeGCJ + "";
            details.lng = data.data.data.hotspot.longitudeGCJ + "";
            if (data.data.data.hotspot.audio != null) {
              details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
            }

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
        // if (isGuide) {
        //   // 有导览
        //   this.$router.push({
        //     path: "/map",
        //     name: "map",
        //     query: { hid: id }
        //   });
        // } else {
        // }
      }
    },

    // 监听detail组件是否展示组件的事件
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      this.details = {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      }; //清空详情组件的details props
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = "搜索";
    this.getHot();
    this.historyWords = JSON.parse(localStorage.getItem("historyWords"));
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed60c22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"search-bar"},[_c('i',{staticClass:"icon-back",on:{"click":function($event){return _vm.$router.go(-1)}}}),_vm._v(" "),_c('div',{staticClass:"search-box"},[_c('i',{staticClass:"icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyWord),expression:"keyWord"}],staticClass:"search-input",attrs:{"id":"searchInput","type":"text","placeholder":"输入要搜索的内容"},domProps:{"value":(_vm.keyWord)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.keyWord=$event.target.value},_vm.inputFun]}})]),_vm._v(" "),_c('div',{staticClass:"search-btn-box",attrs:{"id":"searchBtn"},on:{"click":_vm.getResult}},[_c('span',[_vm._v("搜索")])])]),_vm._v(" "),(!_vm.isShowResult)?_c('div',{staticClass:"history-hot"},[(_vm.historyWords)?_c('div',{staticClass:"history-box section"},[_c('div',{staticClass:"section-title"},[_vm._v("历史记录")]),_vm._v(" "),_c('div',{staticClass:"historys"},_vm._l((_vm.historyWords),function(item,index){return _c('div',{key:index,staticClass:"history-item",on:{"click":function($event){return _vm.search(item)}}},[_vm._v(_vm._s(item))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hot-box section"},[_c('div',{staticClass:"section-title"},[_vm._v("热门搜索")]),_vm._v(" "),_c('div',{staticClass:"hots"},_vm._l((_vm.hotKeywords),function(item,index){return _c('div',{key:index,staticClass:"hot-item",on:{"click":function($event){return _vm.search(item.key_word)}}},[_vm._v(_vm._s(item.key_word))])}),0)])]):_c('div',{staticClass:"result-box"},[(_vm.result.length>0)?_c('div',_vm._l((_vm.result),function(item,index){return _c('div',{key:index,staticClass:"result-item vux-1px-b",on:{"click":function($event){return _vm.resultFun(item.type,item.id,item.is_guide)}}},[_c('span',{staticClass:"item-name ellipsis-1"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"item-type"},[_vm._v(_vm._s(item.typeName))])])}),0):_c('div',{staticClass:"no-result"},[_vm._v("查不到相关数据,换个词试试~")])]),_vm._v(" "),_c('detailPop',{attrs:{"isDetailPopShow":_vm.isDetailPopShow,"details":_vm.details},on:{"changeDetailShow":_vm.changeDetailPop}})],1)}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_search = (search_esExports);
// CONCATENATED MODULE: ./src/pages/search.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("I4bU")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = "data-v-1ed60c22"
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  pages_search,
  selectortype_template_index_0_src_pages_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)

/* harmony default export */ var src_pages_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scenicPoiDetail.vue





/* harmony default export */ var scenicPoiDetail = ({

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {

    return {
      imgList: [],
      hid: this.$route.query.hid,
      pid: null, //对应景区的hid
      content: "",
      address: "",

      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      audioSrc: null,
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值

      scenicHid: null
    };
  },


  computed: {},

  watch: {},

  methods: {
    getDetail: function getDetail() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",

        params: { hid: that.hid },
        success: function success(data) {
          console.log(data.data);
          var result = data.data.data.hotspot;
          var audio = document.getElementById("myaudio");
          that.pid = data.data.data.hotspot.pid;
          that.imgList = data.data.data.imgList;
          that.content = result.description;
          that.address = result.address;
          that.scenicHid = result.pid;
          document.title = result.name;

          if (that.imgList.length == 0) {
            if (data.data.data.hotspot.thumbImg == null) {} else {
              that.imgList = [{ midImg: data.data.data.hotspot.thumbImg }];
            }
          }
          if (result.audio == "" || result.audio == null) {
            that.audioSrc = null;
          } else {
            that.audioSrc = that.GLOBAL.DOMAIN_URL + result.audio.split(".")[0] + ".mp3";
            audio.load();

            audio.addEventListener("canplay", function () {
              that.duration = that.commonFun.transTime(audio.duration);
            });

            if (that.GLOBAL.isWx) {
              if (window.WeixinJSBridge) {
                WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                  that.audioPlay();
                }, false);
              } else {
                document.addEventListener("WeixinJSBridgeReady", function () {
                  WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                    that.audioPlay();
                  });
                }, false);
              }
            }
          }
        },
        isShowLoading: true
      });
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("myaudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("myaudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("myaudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getDetail();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/scenicPoiDetail.vue





/* harmony default export */ var pages_scenicPoiDetail = ({

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {

    return {
      imgList: [],
      hid: this.$route.query.hid,
      pid: null, //对应景区的hid
      content: "",
      address: "",

      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      audioSrc: null,
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值

      scenicHid: null
    };
  },


  computed: {},

  watch: {},

  methods: {
    getDetail: function getDetail() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",

        params: { hid: that.hid },
        success: function success(data) {
          console.log(data.data);
          var result = data.data.data.hotspot;
          var audio = document.getElementById("myaudio");
          that.pid = data.data.data.hotspot.pid;
          that.imgList = data.data.data.imgList;
          that.content = result.description;
          that.address = result.address;
          that.scenicHid = result.pid;
          document.title = result.name;

          if (that.imgList.length == 0) {
            if (data.data.data.hotspot.thumbImg == null) {} else {
              that.imgList = [{ midImg: data.data.data.hotspot.thumbImg }];
            }
          }
          if (result.audio == "" || result.audio == null) {
            that.audioSrc = null;
          } else {
            that.audioSrc = that.GLOBAL.DOMAIN_URL + result.audio.split(".")[0] + ".mp3";
            audio.load();

            audio.addEventListener("canplay", function () {
              that.duration = that.commonFun.transTime(audio.duration);
            });

            if (that.GLOBAL.isWx) {
              if (window.WeixinJSBridge) {
                WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                  that.audioPlay();
                }, false);
              } else {
                document.addEventListener("WeixinJSBridgeReady", function () {
                  WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                    that.audioPlay();
                  });
                }, false);
              }
            }
          }
        },
        isShowLoading: true
      });
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("myaudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("myaudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("myaudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getDetail();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081bd6a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/scenicPoiDetail.vue
var scenicPoiDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",style:(_vm.scenicHid == 52505 ? 'background-color: #ccc' : '')},[(_vm.scenicHid != 52505)?_c('router-link',{staticClass:"backToScenic",attrs:{"to":'map?hid=' + _vm.pid}}):_vm._e(),_vm._v(" "),_c('audio',{attrs:{"id":"myaudio","preload":"auto","src":_vm.audioSrc}}),_vm._v(" "),(_vm.imgList.length != 0)?_c('div',{staticClass:"my-swiper"},[_c('swiper',{attrs:{"height":"3.6rem","loop":true,"auto":true,"show-dots":false}},_vm._l((_vm.imgList),function(item,index){return _c('swiper-item',{key:index},[(_vm.scenicHid == 52505)?_c('div',{staticClass:"swiper-img",style:('background-image:url(' +
            _vm.GLOBAL.DOMAIN_URL +
            item.midImg.split('_r16_c9_480_293')[0] +
            '.jpg' +
            ')')}):_c('img',{attrs:{"src":_vm.GLOBAL.DOMAIN_URL + item.midImg,"alt":""}})])}),1),_vm._v(" "),(_vm.scenicHid != 52505)?_c('div',{staticClass:"detail-add"},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',{staticClass:"ellipsis-1"},[_vm._v(_vm._s(_vm.address))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.audioSrc != null)?_c('div',{staticClass:"player-box"},[_c('div',{class:['audio-left', _vm.playing ? 'play' : 'pause'],attrs:{"id":"audioPlayer"},on:{"click":_vm.audioPlay}}),_vm._v(" "),_c('div',{staticClass:"audio-right"},[_c('div',{staticClass:"progress-bar-bg",attrs:{"id":"progressBarBg"},on:{"mousedown":_vm.progressBarBg}},[_c('span',{style:('left:' + _vm.dotLeft + '%'),attrs:{"id":"progressDot"},on:{"mousedown":_vm.progressDot}}),_vm._v(" "),_c('div',{staticClass:"progress-bar",style:('width:' + _vm.barWidth + '%'),attrs:{"id":"progressBar"}})]),_vm._v(" "),_c('div',{staticClass:"audio-time"},[_c('span',{staticClass:"audio-length-current",attrs:{"id":"audioCurTime"}},[_vm._v(_vm._s(_vm.audioCurTime))]),_vm._v("/\n        "),_c('span',{staticClass:"audio-length-total"},[_vm._v(_vm._s(_vm.duration))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contents"},[_c('div',{staticClass:"content-title"},[_vm._v("简介")]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"id":"detailContent"},domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])])],1)}
var scenicPoiDetail_staticRenderFns = []
var scenicPoiDetail_esExports = { render: scenicPoiDetail_render, staticRenderFns: scenicPoiDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_scenicPoiDetail = (scenicPoiDetail_esExports);
// CONCATENATED MODULE: ./src/pages/scenicPoiDetail.vue
function scenicPoiDetail_injectStyle (ssrContext) {
  __webpack_require__("ux2s")
  __webpack_require__("5wrV")
}
var scenicPoiDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scenicPoiDetail___vue_template_functional__ = false
/* styles */
var scenicPoiDetail___vue_styles__ = scenicPoiDetail_injectStyle
/* scopeId */
var scenicPoiDetail___vue_scopeId__ = "data-v-081bd6a0"
/* moduleIdentifier (server only) */
var scenicPoiDetail___vue_module_identifier__ = null
var scenicPoiDetail_Component = scenicPoiDetail_normalizeComponent(
  pages_scenicPoiDetail,
  selectortype_template_index_0_src_pages_scenicPoiDetail,
  scenicPoiDetail___vue_template_functional__,
  scenicPoiDetail___vue_styles__,
  scenicPoiDetail___vue_scopeId__,
  scenicPoiDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_scenicPoiDetail = (scenicPoiDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/map.vue













/* harmony default export */ var map = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    getLocation: src_components_getLocation,
    leLayer: src_components_leLayer,
    Popup: node_modules_vux_src_components_popup,
    detailPop: src_components_detailPop,
    scenicPop: src_components_scenicPop
  },
  inject: ["reload"], //注入app.vue组件的依赖 当前页面改路由跳转用
  data: function data() {

    return {

      funImg: {
        locationImgDefault: "", // 定位按钮
        locationImgActive: "", // 定位按钮选中
        searchImgDefault: "", // 搜索按钮
        viewImgDefault: "", // 手绘按钮
        viewImgActive: "", // 手绘按钮选中
        lineImgDefault: "", // 线路按钮
        lineImgActive: "", // 线路按钮选中
        nearImgDefault: "", // 周边按钮
        nearImgActive: "", // 周边按钮选中
        funFull: {
          img: "", //全景按钮
          url: ""
        },
        funShop: {
          img: "", //商城按钮
          url: ""
        },
        funAct: {
          img: "", //活动按钮
          url: ""
        },
        funTicket: {
          img: "", //门票按钮
          url: ""
        },
        funTraffic: {
          img: "", //交通按钮
          url: ""
        },
        funComplaint: {
          img: "", //投诉按钮
          url: ""
        },
        funNotice: {
          img: "", //公告按钮
          url: ""
        }
      },

      audioSrc: null,
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值


      scenicData: null, //景区数据
      mapObj: null, //地图实例
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //景区电子围栏范围
      hid: this.$route.query.hid ? this.$route.query.hid : 1156,
      leLayer: null, //瓦片实例
      isLelayerShow: true, //瓦片展示
      poiType: null, //poi类别
      isPoiTypeListShow: true, //周边列表是否展示
      activePoiTypeId: 2, //当前展示的poi的typeid
      activePoiTypeIndex: null, //当前展示的poi类型在PoiType中的下标
      infoWindow: null, //信息窗体实例
      mapMaxZoom: null, //地图最大层级
      mapMinZoom: null, //地图最小层级
      scenicZoom: null, //当前景区展示层级


      curMarkerArr: null, //当前展示的markers
      isLineShow: false, //线路是否展示
      polyline: null, //线路的线的实体
      lines: [[{
        description: "",
        imgurl: "",
        lineLatLng: [],
        lineMarkers: [],
        lineName: "",
        lineTime: "",
        scenicNum: ""
      }]], //线路点位
      lineIndex: 0, //当前展示的线路的在所有线路集合中的下标
      curLinePoiIndex: -1, //当前选中的线路 选中的点位的下标
      lineVal: {
        id: "",
        is_guide: 0
      },
      curLine: {},

      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      isScenicPopShow: false,
      scenicPopData: {}
    };
  },


  computed: {},

  watch: {
    $route: function $route(to, from) {

      this.refresh();

      document.location.reload();
    },
    curLinePoiIndex: function curLinePoiIndex(newV) {
      if (newV == -1) {
        console.log("隐藏线路音频");
        this.audioEnded();
        if (!document.getElementById("myaudio").paused) {

          document.getElementById("myaudio").pause();
        }
      }
    }
  },

  methods: {
    refresh: function refresh() {
      this.reload();
    },
    getScenicData: function getScenicData(hid) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
        params: {
          hid: hid
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.scenicData = data.data.data.data.scenic;
          document.title = data.data.data.data.scenic.name;
          that.mapMaxZoom = data.data.data.data.scenic.max_zoom;
          that.scenicLng = data.data.data.data.scenic.longitude;
          that.scenicLat = data.data.data.data.scenic.latitude;
          that.mapMinZoom = data.data.data.data.scenic.min_zoom;
          that.scenicZoom = data.data.data.data.scenic.rank;
          var componentList = data.data.data.data.componentList;

          for (var i in componentList) {
            if (componentList[i].com_id == 23) {

              that.funImg.viewImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.viewImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 21) {

              that.funImg.locationImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.locationImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 22) {

              that.funImg.searchImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
            } else if (componentList[i].com_id == 13) {

              that.funImg.funFull.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funFull.url = componentList[i].url;
            } else if (componentList[i].com_id == 14) {

              that.funImg.funShop.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funShop.url = componentList[i].url;
            } else if (componentList[i].com_id == 15) {

              that.funImg.funComplaint.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funComplaint.url = componentList[i].url;
            } else if (componentList[i].com_id == 16) {

              that.funImg.funTicket.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funTicket.url = componentList[i].url;
            } else if (componentList[i].com_id == 17) {

              that.funImg.funTraffic.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funTraffic.url = componentList[i].url;
            } else if (componentList[i].com_id == 18) {

              that.funImg.funNotice.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funNotice.url = componentList[i].url;
            } else if (componentList[i].com_id == 19) {

              that.funImg.funAct.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funAct.url = componentList[i].url;
            } else if (componentList[i].com_id == 24) {

              that.funImg.nearImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.nearImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 25) {

              that.funImg.lineImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.lineImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            }
          }

          that.setPoiType(data.data.data.data.hotTypeList);

          that.setPois(that.scenicData.pointses);
          that.setScenicPois(data.data.data.data.childHotspotList);

          that.getMap();

          that.setLine(that.scenicData.hotspotLinesList);
        }
      });
    },
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: that.scenicZoom, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });

      for (var i in that.scenicData.polygons) {
        that.scenicBound.push([that.scenicData.polygons[i].longitude, that.scenicData.polygons[i].latitude]);
      }

      that.curMarkerArr = that.poiType[that.activePoiTypeIndex].poiArr[that.mapObj.getZoom() - that.mapMinZoom];

      that.mapObj.add(that.curMarkerArr);

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      that.isLocation = true;
      that.mapObj.on("complete", function () {});

      AMap.event.addListener(that.mapObj, "zoomend", function () {

        that.scenicZoom = that.mapObj.getZoom();
        console.log("当前地图层级==" + that.mapObj.getZoom());

        that.mapObj.clearInfoWindow();
        that.mapMoveEnd();
      });

      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 300)
        }));
      });
    },
    mapMoveEnd: function mapMoveEnd() {
      if (this.isLineShow) {} else {
        this.mapObj.remove(this.curMarkerArr);
        this.addPoi();
      }
    },
    setPois: function setPois(arr) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in arr) {
        if (arr[i].type != 1) {

          if (arr[i].l_type == 1) {
            var default_type_bg = void 0;
            var icon_default = void 0;
            var icon_active = void 0;
            var typeIndex = void 0;
            var isHasThisType = false;

            for (var j in that.poiType) {
              if (arr[i].type == that.poiType[j].id) {
                default_type_bg = that.poiType[j].defaultBg;
                icon_default = that.poiType[j].poiDefaultBg;
                icon_active = that.poiType[j].poiActiveBg;
                typeIndex = j;
                isHasThisType = true;
                that.poiType[j].isHasPoi = true;
                break;
              }
            }

            if (!isHasThisType) {
              console.log("点位类别没有类别type===" + arr[i].type);
              continue;
            }
            var marker = new AMap.Marker({

              position: new AMap.LngLat(arr[i].longitude, arr[i].latitude),

              content: "<div class='poi'><img class='iconall' id='poi" + i + "' src='" + that.GLOBAL.DOMAIN_URL + icon_default + "'><span class='poiName'>" + arr[i].chs_name + "</span></div>",
              offset: new AMap.Pixel(-15, -30),
              extData: {

                poiType: arr[i].type,
                poiData: arr[i],
                index: i,
                default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
                icon_default: icon_default, //poi的marker点的默认图标
                icon_active: icon_active
              }
            });

            AMap.event.addListener(marker, "click", function (e) {
              this.setTop(true);
              var position = e.target.getPosition();
              var extData = e.target.getExtData();
              console.log(extData);
              that.mapObj.setCenter(position);
              if (extData.poiType == 2) {

                var data = {
                  address: extData.poiData.address,
                  audio: extData.poiData.audio,
                  id: extData.poiData.hid,
                  is_guide: 0,
                  latitude_gcj: extData.poiData.latitude,
                  longitude_gcj: extData.poiData.longitude,
                  name: extData.poiData.chs_name,
                  thumb_img: extData.poiData.thumbImg
                };
                that.scenicPopData = data;
                that.isScenicPopShow = true;
              } else {
                that.poiMarkerFun(extData, position);
              }
            });

            var min = arr[i].min_zoom - that.mapMinZoom;
            for (var z = 0; z < poiZoomRange + 1; z++) {
              if (z >= min) {
                that.poiType[typeIndex].poiArr[z].push(marker);
              }
            }
          }
        }
      }
    },
    setScenicPois: function setScenicPois(arr) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in arr) {
        var default_type_bg = that.poiType[0].defaultBg;
        var icon_default = that.poiType[0].poiDefaultBg;
        var icon_active = that.poiType[0].poiActiveBg;
        that.poiType[0].isHasPoi = true;

        var marker = new AMap.Marker({

          position: new AMap.LngLat(arr[i].longitude_gcj, arr[i].latitude_gcj),

          content: "<div class='poi'><img class='iconall' id='poi" + i + "' src='" + that.GLOBAL.DOMAIN_URL + icon_default + "'><span class='poiName'>" + arr[i].hotspot_name + "</span></div>",
          offset: new AMap.Pixel(-15, -30),
          extData: {

            poiData: arr[i],
            index: i,
            default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
            icon_default: icon_default, //poi的marker点的默认图标
            icon_active: icon_active
          }
        });

        AMap.event.addListener(marker, "click", function (e) {
          this.setTop(true);
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          console.log(extData);
          that.mapObj.setCenter(position);

          var data = {
            audio: extData.poiData.audio,
            id: extData.poiData.hotspot_id,
            is_guide: extData.poiData.is_guide,
            latitude_gcj: extData.poiData.latitude_gcj,
            longitude_gcj: extData.poiData.longitude_gcj,
            name: extData.poiData.hotspot_name,
            thumb_img: extData.poiData.thumb_img
          };
          that.scenicPopData = data;
          that.isScenicPopShow = true;
        });

        for (var z = 0; z < poiZoomRange + 1; z++) {

          that.poiType[0].poiArr[z].push(marker);
        }
      }
    },
    setLine: function setLine(arr) {
      var that = this;
      var icon_default = void 0;
      var icon_active = void 0;
      that.lines = [];
      console.log(arr);
      if (!arr.length > 0) {
        return;
      }
      for (var i in arr) {
        var obj = {};
        obj.description = arr[i].description;
        obj.lineName = arr[i].lineName;
        obj.lineTime = arr[i].reserved3;
        obj.scenicNum = arr[i].reserved4;
        obj.imgurl = arr[i].imgurl;
        obj.lineLatLng = [];
        obj.lineMarkers = [];
        obj.linePoiName = [];
        var z = 1;
        for (var j in arr[i].coordinateList) {
          obj.lineLatLng.push(new AMap.LngLat(Number(arr[i].coordinateList[j].longitude), Number(arr[i].coordinateList[j].latitude)));

          if (arr[i].coordinateList[j].reserved1.indexOf("默认") == -1) {
            obj.linePoiName.push(arr[i].coordinateList[j].reserved1);
            var marker = new AMap.Marker({

              content: '<div class="line-markers" id="linePoi' + (z - 1) + '"><div class="line-marker"><span>' + z + '</span></div><div class="line-infobox" style="background-image:url(\'./static/img/go.gif\');" id="lineInfo' + (z - 1) + '"><div class="line-info"><i class="info-close"></i><div class="line-infoTop"><img src="' + (that.GLOBAL.DOMAIN_URL + arr[i].coordinateList[j].thumb_img) + '"><div class="info-title-des"><div class="info-title ellipsis-1">' + arr[i].coordinateList[j].reserved1 + '</div><div class="info-des">' + arr[i].coordinateList[j].intro + '</div></div><div class="info-more"></div></div><div class="info-go" data-name="' + arr[i].coordinateList[j].reserved1 + '" data-lat="' + arr[i].coordinateList[j].latitude + '" data-lng="' + arr[i].coordinateList[j].longitude + '"><i class="icon-go"></i><div>\u5230\u8FD9\u91CC</div></div></div></div></div>',
              position: new AMap.LngLat(arr[i].coordinateList[j].longitude, arr[i].coordinateList[j].latitude),

              offset: new AMap.Pixel(-18, -36),
              extData: {
                name: arr[i].coordinateList[j].reserved1,
                audio: arr[i].coordinateList[j].audio,
                thumb_img: arr[i].coordinateList[j].thumb_img,
                hid: arr[i].coordinateList[j].reserved2,
                id: arr[i].coordinateList[j].id,
                domId: "linePoi" + (z - 1),
                index: z - 1

              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var thisPosition = e.target.getPosition();
              var extData = e.target.getExtData();
              that.curLinePoiIndex = extData.index;
              this.setTop(true);

              that.scrollLeftTo(document.getElementsByClassName("line-poi-item")[extData.index], document.getElementById("linePois"), extData.index);

              that.linePoiFun(extData, thisPosition);
            });

            obj.lineMarkers.push(marker);
            z++;
          }
        }
        that.lines.push(obj);
      }
      console.log(that.lines);
    },
    openLineDetail: function openLineDetail() {

      var audio = document.getElementById("myaudio");

      if (!audio.paused) {

        audio.pause();
        this.playing = false;
      }
      this.getScenicDetailFromScenicPop(this.lineVal);
    },
    scrollLeftTo: function scrollLeftTo(element, elementFather, index) {
      var actualLeft = element.offsetLeft;
      var current = element.offsetParent;
      actualLeft += current.offsetLeft;
      current = current.offsetParent;
      elementFather.scrollLeft = actualLeft - element.clientWidth * 2;
    },
    showLine: function showLine() {
      if (this.isLineShow) {
        this.isLineShow = !this.isLineShow;
        this.mapObj.remove(this.curMarkerArr);
        this.mapObj.remove(this.polyline);
        this.polyline = null;
        this.curLinePoiIndex = -1;
        document.getElementById("linePois").scrollLeft = 0;

        this.addPoi();
      } else {
        this.isScenicPopShow = false;
        this.isLineShow = !this.isLineShow;

        this.mapObj.remove(this.curMarkerArr);
        this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
        this.mapObj.add(this.curMarkerArr);
        if (this.polyline == "" || this.polyline == undefined || this.polyline == null) {
          this.polyline = new AMap.Polyline({
            path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
            strokeColor: "#f56b61", //线颜色
            strokeOpacity: 0.8, //线透明度
            strokeWeight: 3, //线宽
            strokeStyle: "solid", //线样式
            isOutline: true,
            borderWeight: 1,
            outlineColor: "#fff",
            lineJoin: "round",
            lineCap: "round",
            strokeDasharray: [10, 5], //补充线样式
            zIndex: 9999
          });
          this.polyline.setMap(this.mapObj);
        } else {
          this.mapObj.remove(this.polyline);
        }
        this.mapObj.setFitView();
      }
    },
    changeLine: function changeLine(i) {
      if (i == this.lineIndex) {
        return;
      } else {
        this.lineIndex = i;
        this.curLinePoiIndex = -1;
        document.getElementById("linePois").scrollLeft = 0;
        this.mapObj.remove(this.curMarkerArr);
        if (this.polyline != null) {
          this.mapObj.remove(this.polyline);
          this.polyline = null;
        }
        this.polyline = new AMap.Polyline({
          path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
          strokeColor: "#f56b61", //线颜色
          strokeOpacity: 0.8, //线透明度
          strokeWeight: 3, //线宽
          strokeStyle: "solid", //线样式
          isOutline: true,
          borderWeight: 1,
          outlineColor: "#fff",
          lineJoin: "round",
          lineCap: "round",
          strokeDasharray: [10, 5], //补充线样式
          zIndex: 9999
        });
        this.polyline.setMap(this.mapObj);
        this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
        this.mapObj.add(this.curMarkerArr);
        this.mapObj.setFitView();
      }
    },
    changeCurLinePoiIndex: function changeCurLinePoiIndex(i) {
      if (i == this.curLinePoiIndex) {
        return;
      } else {
        this.curLinePoiIndex = i;
        var marker = this.lines[this.lineIndex].lineMarkers[i];
        marker.setTop(true);

        this.scrollLeftTo(document.getElementsByClassName("line-poi-item")[marker.getExtData().index], document.getElementById("linePois"), marker.getExtData().index);

        this.linePoiFun(marker.getExtData(), marker.getPosition());
      }
    },
    linePoiFun: function linePoiFun(data, position) {
      var that = this;
      console.log(data);
      console.log(position);
      that.lineVal.id = data.hid;

      this.mapObj.setCenter(position);

      if (document.getElementsByClassName("markerOn")[0] != undefined) {
        document.getElementsByClassName("markerOn")[0].classList.remove("markerOn");
      }
      var classVal = document.getElementById(data.domId).getAttribute("class");
      classVal = classVal.concat(" markerOn");
      document.getElementById(data.domId).setAttribute("class", classVal);
      var audio = document.getElementById("myaudio");
      that.audioSrc = that.GLOBAL.DOMAIN_URL + data.audio.split(".")[0] + ".mp3";
      audio.load();
      that.playing = false;
      this.barWidth = 0;
      this.dotLeft = 0;

      if (that.GLOBAL.isWx) {
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
            that.audioPlay();
          }, false);
        } else {
          document.addEventListener("WeixinJSBridgeReady", function () {
            WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
              that.audioPlay();
            });
          }, false);
        }
      } else {}

      document.getElementById(data.domId).getElementsByClassName("info-close")[0].addEventListener("touchstart", function () {
        that.curLinePoiIndex = -1;

        document.getElementsByClassName("markerOn")[0].classList.remove("markerOn");
      }, false);

      document.getElementById(data.domId).getElementsByClassName("info-go")[0].addEventListener("touchstart", function () {
        console.log("高德导航");
        var name = this.getAttribute("data-name");
        var lat = this.getAttribute("data-lat");
        var lng = this.getAttribute("data-lng");
        that.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
      }, false);

      document.getElementById(data.domId).getElementsByClassName("info-title-des")[0].addEventListener("touchstart", function () {
        that.openLineDetail();
      }, false);
    },
    setPoiType: function setPoiType(arr) {
      var that = this;
      that.poiType = [];
      for (var i in arr) {
        var obj = {};
        obj.id = arr[i].points_type_id;
        obj.name = arr[i].type_name;
        obj.defaultBg = arr[i].icon;
        obj.activeBg = arr[i].picth_icon;
        obj.poiDefaultBg = arr[i].point_icon;
        obj.poiActiveBg = arr[i].point_picth_icon;
        obj.poiArr = [];
        obj.isHasPoi = false;
        if (arr[i].points_type_id == 2) {
          that.activePoiTypeIndex = i;
        }
        for (var j = that.mapMinZoom; j <= that.mapMaxZoom; j++) {
          obj.poiArr.push([]);
        }
        that.poiType.push(obj);
      }
      console.log(that.poiType);
    },
    changePoiType: function changePoiType(typeId, i) {
      console.log("changePoiType");
      var that = this;

      if (this.isLineShow) {

        that.$vux.toast.text("请先退出线路", "bottom");
        return;
      } else {
        if (typeId == that.activePoiTypeId) {

          return;
        } else {
          that.mapObj.clearInfoWindow();
          that.activePoiTypeId = typeId;
          that.activePoiTypeIndex = i;
          that.mapObj.remove(this.curMarkerArr);
          that.addPoi();
          that.isScenicPopShow = false;
        }
      }
    },
    poiMarkerFun: function poiMarkerFun(data, position) {
      var that = this;
      if (data.poiData.type == 2) {

        that.$router.push({
          path: "/scenicPoiDetail",
          name: "scenicPoiDetail",
          query: { hid: data.poiData.hid }
        });
      } else {
        var distance = (this.commonFun.getGreatCircleDistance(sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), position.lat, position.lng) / 1000).toFixed(2);
        var title = "<img src='" + that.GLOBAL.DOMAIN_URL + data.default_type_bg + "' /><span>" + distance + "km</span>";

        var middle = "<div id='infoNav' data-name='" + data.poiData.chs_name + "' data-lat='" + position.lat + "' data-lng='" + position.lng + "'><i></i><span>到这里</span></div>";

        this.infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: this.createInfoWindow(title, middle),
          offset: new AMap.Pixel(0, -34)
        });
        this.infoWindow.open(this.mapObj, position);

        setTimeout(function () {
          that.mapObj.setCenter([position.lng, position.lat]);
          document.getElementById("infoNav").addEventListener("click", function () {
            console.log("高德导航");
            var name = this.getAttribute("data-name");
            var lat = this.getAttribute("data-lat");
            var lng = this.getAttribute("data-lng");
            that.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
          }, false);
        }, 50);
      }
    },
    createInfoWindow: function createInfoWindow(title, mContent) {
      var info = document.createElement("div");
      info.className = "content-window-card";

      var top = document.createElement("div");

      top.className = "info-top vux-1px-b";
      top.innerHTML = title;
      info.appendChild(top);

      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.innerHTML = mContent;
      info.appendChild(middle);

      return info;
    },
    addPoi: function addPoi() {

      this.curMarkerArr = this.poiType[this.activePoiTypeIndex].poiArr[this.mapObj.getZoom() - this.mapMinZoom];
      this.mapObj.add(this.curMarkerArr);
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      this.details = {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      }; //清空详情组件的details props
    },
    changeScenicPop: function changeScenicPop(val) {
      this.isScenicPopShow = val;
    },
    getScenicDetailFromScenicPop: function getScenicDetailFromScenicPop(val) {
      var that = this;

      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: val.id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = val.is_guide;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          for (var i in data.data.data.imgList) {
            details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
        }
      });
      this.isScenicPopShow = false;
      this.isDetailPopShow = true;
    },
    isPTListShow: function isPTListShow() {
      this.isPoiTypeListShow = !this.isPoiTypeListShow;
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("myaudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("myaudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      console.log("click");
      var that = this;
      var audio = document.getElementById("myaudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      console.log("同步进度条");
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
    },
    openOutUrl: function openOutUrl(url) {
      window.location.href = url;
    }
  },

  created: function created() {
    this.getScenicData(this.hid);
  },
  mounted: function mounted() {
    console.log(this.$route.query);
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/map.vue













/* harmony default export */ var pages_map = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    getLocation: src_components_getLocation,
    leLayer: src_components_leLayer,
    Popup: node_modules_vux_src_components_popup,
    detailPop: src_components_detailPop,
    scenicPop: src_components_scenicPop
  },
  inject: ["reload"], //注入app.vue组件的依赖 当前页面改路由跳转用
  data: function data() {

    return {

      funImg: {
        locationImgDefault: "", // 定位按钮
        locationImgActive: "", // 定位按钮选中
        searchImgDefault: "", // 搜索按钮
        viewImgDefault: "", // 手绘按钮
        viewImgActive: "", // 手绘按钮选中
        lineImgDefault: "", // 线路按钮
        lineImgActive: "", // 线路按钮选中
        nearImgDefault: "", // 周边按钮
        nearImgActive: "", // 周边按钮选中
        funFull: {
          img: "", //全景按钮
          url: ""
        },
        funShop: {
          img: "", //商城按钮
          url: ""
        },
        funAct: {
          img: "", //活动按钮
          url: ""
        },
        funTicket: {
          img: "", //门票按钮
          url: ""
        },
        funTraffic: {
          img: "", //交通按钮
          url: ""
        },
        funComplaint: {
          img: "", //投诉按钮
          url: ""
        },
        funNotice: {
          img: "", //公告按钮
          url: ""
        }
      },

      audioSrc: null,
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值


      scenicData: null, //景区数据
      mapObj: null, //地图实例
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //景区电子围栏范围
      hid: this.$route.query.hid ? this.$route.query.hid : 1156,
      leLayer: null, //瓦片实例
      isLelayerShow: true, //瓦片展示
      poiType: null, //poi类别
      isPoiTypeListShow: true, //周边列表是否展示
      activePoiTypeId: 2, //当前展示的poi的typeid
      activePoiTypeIndex: null, //当前展示的poi类型在PoiType中的下标
      infoWindow: null, //信息窗体实例
      mapMaxZoom: null, //地图最大层级
      mapMinZoom: null, //地图最小层级
      scenicZoom: null, //当前景区展示层级


      curMarkerArr: null, //当前展示的markers
      isLineShow: false, //线路是否展示
      polyline: null, //线路的线的实体
      lines: [[{
        description: "",
        imgurl: "",
        lineLatLng: [],
        lineMarkers: [],
        lineName: "",
        lineTime: "",
        scenicNum: ""
      }]], //线路点位
      lineIndex: 0, //当前展示的线路的在所有线路集合中的下标
      curLinePoiIndex: -1, //当前选中的线路 选中的点位的下标
      lineVal: {
        id: "",
        is_guide: 0
      },
      curLine: {},

      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      isScenicPopShow: false,
      scenicPopData: {}
    };
  },


  computed: {},

  watch: {
    $route: function $route(to, from) {

      this.refresh();

      document.location.reload();
    },
    curLinePoiIndex: function curLinePoiIndex(newV) {
      if (newV == -1) {
        console.log("隐藏线路音频");
        this.audioEnded();
        if (!document.getElementById("myaudio").paused) {

          document.getElementById("myaudio").pause();
        }
      }
    }
  },

  methods: {
    refresh: function refresh() {
      this.reload();
    },
    getScenicData: function getScenicData(hid) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
        params: {
          hid: hid
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.scenicData = data.data.data.data.scenic;
          document.title = data.data.data.data.scenic.name;
          that.mapMaxZoom = data.data.data.data.scenic.max_zoom;
          that.scenicLng = data.data.data.data.scenic.longitude;
          that.scenicLat = data.data.data.data.scenic.latitude;
          that.mapMinZoom = data.data.data.data.scenic.min_zoom;
          that.scenicZoom = data.data.data.data.scenic.rank;
          var componentList = data.data.data.data.componentList;

          for (var i in componentList) {
            if (componentList[i].com_id == 23) {

              that.funImg.viewImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.viewImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 21) {

              that.funImg.locationImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.locationImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 22) {

              that.funImg.searchImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
            } else if (componentList[i].com_id == 13) {

              that.funImg.funFull.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funFull.url = componentList[i].url;
            } else if (componentList[i].com_id == 14) {

              that.funImg.funShop.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funShop.url = componentList[i].url;
            } else if (componentList[i].com_id == 15) {

              that.funImg.funComplaint.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funComplaint.url = componentList[i].url;
            } else if (componentList[i].com_id == 16) {

              that.funImg.funTicket.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funTicket.url = componentList[i].url;
            } else if (componentList[i].com_id == 17) {

              that.funImg.funTraffic.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funTraffic.url = componentList[i].url;
            } else if (componentList[i].com_id == 18) {

              that.funImg.funNotice.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funNotice.url = componentList[i].url;
            } else if (componentList[i].com_id == 19) {

              that.funImg.funAct.img = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.funAct.url = componentList[i].url;
            } else if (componentList[i].com_id == 24) {

              that.funImg.nearImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.nearImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            } else if (componentList[i].com_id == 25) {

              that.funImg.lineImgDefault = that.GLOBAL.DOMAIN_URL + componentList[i].icon;
              that.funImg.lineImgActive = that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
            }
          }

          that.setPoiType(data.data.data.data.hotTypeList);

          that.setPois(that.scenicData.pointses);
          that.setScenicPois(data.data.data.data.childHotspotList);

          that.getMap();

          that.setLine(that.scenicData.hotspotLinesList);
        }
      });
    },
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: that.scenicZoom, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });

      for (var i in that.scenicData.polygons) {
        that.scenicBound.push([that.scenicData.polygons[i].longitude, that.scenicData.polygons[i].latitude]);
      }

      that.curMarkerArr = that.poiType[that.activePoiTypeIndex].poiArr[that.mapObj.getZoom() - that.mapMinZoom];

      that.mapObj.add(that.curMarkerArr);

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      that.isLocation = true;
      that.mapObj.on("complete", function () {});

      AMap.event.addListener(that.mapObj, "zoomend", function () {

        that.scenicZoom = that.mapObj.getZoom();
        console.log("当前地图层级==" + that.mapObj.getZoom());

        that.mapObj.clearInfoWindow();
        that.mapMoveEnd();
      });

      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 300)
        }));
      });
    },
    mapMoveEnd: function mapMoveEnd() {
      if (this.isLineShow) {} else {
        this.mapObj.remove(this.curMarkerArr);
        this.addPoi();
      }
    },
    setPois: function setPois(arr) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in arr) {
        if (arr[i].type != 1) {

          if (arr[i].l_type == 1) {
            var default_type_bg = void 0;
            var icon_default = void 0;
            var icon_active = void 0;
            var typeIndex = void 0;
            var isHasThisType = false;

            for (var j in that.poiType) {
              if (arr[i].type == that.poiType[j].id) {
                default_type_bg = that.poiType[j].defaultBg;
                icon_default = that.poiType[j].poiDefaultBg;
                icon_active = that.poiType[j].poiActiveBg;
                typeIndex = j;
                isHasThisType = true;
                that.poiType[j].isHasPoi = true;
                break;
              }
            }

            if (!isHasThisType) {
              console.log("点位类别没有类别type===" + arr[i].type);
              continue;
            }
            var marker = new AMap.Marker({

              position: new AMap.LngLat(arr[i].longitude, arr[i].latitude),

              content: "<div class='poi'><img class='iconall' id='poi" + i + "' src='" + that.GLOBAL.DOMAIN_URL + icon_default + "'><span class='poiName'>" + arr[i].chs_name + "</span></div>",
              offset: new AMap.Pixel(-15, -30),
              extData: {

                poiType: arr[i].type,
                poiData: arr[i],
                index: i,
                default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
                icon_default: icon_default, //poi的marker点的默认图标
                icon_active: icon_active
              }
            });

            AMap.event.addListener(marker, "click", function (e) {
              this.setTop(true);
              var position = e.target.getPosition();
              var extData = e.target.getExtData();
              console.log(extData);
              that.mapObj.setCenter(position);
              if (extData.poiType == 2) {

                var data = {
                  address: extData.poiData.address,
                  audio: extData.poiData.audio,
                  id: extData.poiData.hid,
                  is_guide: 0,
                  latitude_gcj: extData.poiData.latitude,
                  longitude_gcj: extData.poiData.longitude,
                  name: extData.poiData.chs_name,
                  thumb_img: extData.poiData.thumbImg
                };
                that.scenicPopData = data;
                that.isScenicPopShow = true;
              } else {
                that.poiMarkerFun(extData, position);
              }
            });

            var min = arr[i].min_zoom - that.mapMinZoom;
            for (var z = 0; z < poiZoomRange + 1; z++) {
              if (z >= min) {
                that.poiType[typeIndex].poiArr[z].push(marker);
              }
            }
          }
        }
      }
    },
    setScenicPois: function setScenicPois(arr) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in arr) {
        var default_type_bg = that.poiType[0].defaultBg;
        var icon_default = that.poiType[0].poiDefaultBg;
        var icon_active = that.poiType[0].poiActiveBg;
        that.poiType[0].isHasPoi = true;

        var marker = new AMap.Marker({

          position: new AMap.LngLat(arr[i].longitude_gcj, arr[i].latitude_gcj),

          content: "<div class='poi'><img class='iconall' id='poi" + i + "' src='" + that.GLOBAL.DOMAIN_URL + icon_default + "'><span class='poiName'>" + arr[i].hotspot_name + "</span></div>",
          offset: new AMap.Pixel(-15, -30),
          extData: {

            poiData: arr[i],
            index: i,
            default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
            icon_default: icon_default, //poi的marker点的默认图标
            icon_active: icon_active
          }
        });

        AMap.event.addListener(marker, "click", function (e) {
          this.setTop(true);
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          console.log(extData);
          that.mapObj.setCenter(position);

          var data = {
            audio: extData.poiData.audio,
            id: extData.poiData.hotspot_id,
            is_guide: extData.poiData.is_guide,
            latitude_gcj: extData.poiData.latitude_gcj,
            longitude_gcj: extData.poiData.longitude_gcj,
            name: extData.poiData.hotspot_name,
            thumb_img: extData.poiData.thumb_img
          };
          that.scenicPopData = data;
          that.isScenicPopShow = true;
        });

        for (var z = 0; z < poiZoomRange + 1; z++) {

          that.poiType[0].poiArr[z].push(marker);
        }
      }
    },
    setLine: function setLine(arr) {
      var that = this;
      var icon_default = void 0;
      var icon_active = void 0;
      that.lines = [];
      console.log(arr);
      if (!arr.length > 0) {
        return;
      }
      for (var i in arr) {
        var obj = {};
        obj.description = arr[i].description;
        obj.lineName = arr[i].lineName;
        obj.lineTime = arr[i].reserved3;
        obj.scenicNum = arr[i].reserved4;
        obj.imgurl = arr[i].imgurl;
        obj.lineLatLng = [];
        obj.lineMarkers = [];
        obj.linePoiName = [];
        var z = 1;
        for (var j in arr[i].coordinateList) {
          obj.lineLatLng.push(new AMap.LngLat(Number(arr[i].coordinateList[j].longitude), Number(arr[i].coordinateList[j].latitude)));

          if (arr[i].coordinateList[j].reserved1.indexOf("默认") == -1) {
            obj.linePoiName.push(arr[i].coordinateList[j].reserved1);
            var marker = new AMap.Marker({

              content: '<div class="line-markers" id="linePoi' + (z - 1) + '"><div class="line-marker"><span>' + z + '</span></div><div class="line-infobox" style="background-image:url(\'./static/img/go.gif\');" id="lineInfo' + (z - 1) + '"><div class="line-info"><i class="info-close"></i><div class="line-infoTop"><img src="' + (that.GLOBAL.DOMAIN_URL + arr[i].coordinateList[j].thumb_img) + '"><div class="info-title-des"><div class="info-title ellipsis-1">' + arr[i].coordinateList[j].reserved1 + '</div><div class="info-des">' + arr[i].coordinateList[j].intro + '</div></div><div class="info-more"></div></div><div class="info-go" data-name="' + arr[i].coordinateList[j].reserved1 + '" data-lat="' + arr[i].coordinateList[j].latitude + '" data-lng="' + arr[i].coordinateList[j].longitude + '"><i class="icon-go"></i><div>\u5230\u8FD9\u91CC</div></div></div></div></div>',
              position: new AMap.LngLat(arr[i].coordinateList[j].longitude, arr[i].coordinateList[j].latitude),

              offset: new AMap.Pixel(-18, -36),
              extData: {
                name: arr[i].coordinateList[j].reserved1,
                audio: arr[i].coordinateList[j].audio,
                thumb_img: arr[i].coordinateList[j].thumb_img,
                hid: arr[i].coordinateList[j].reserved2,
                id: arr[i].coordinateList[j].id,
                domId: "linePoi" + (z - 1),
                index: z - 1

              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var thisPosition = e.target.getPosition();
              var extData = e.target.getExtData();
              that.curLinePoiIndex = extData.index;
              this.setTop(true);

              that.scrollLeftTo(document.getElementsByClassName("line-poi-item")[extData.index], document.getElementById("linePois"), extData.index);

              that.linePoiFun(extData, thisPosition);
            });

            obj.lineMarkers.push(marker);
            z++;
          }
        }
        that.lines.push(obj);
      }
      console.log(that.lines);
    },
    openLineDetail: function openLineDetail() {

      var audio = document.getElementById("myaudio");

      if (!audio.paused) {

        audio.pause();
        this.playing = false;
      }
      this.getScenicDetailFromScenicPop(this.lineVal);
    },
    scrollLeftTo: function scrollLeftTo(element, elementFather, index) {
      var actualLeft = element.offsetLeft;
      var current = element.offsetParent;
      actualLeft += current.offsetLeft;
      current = current.offsetParent;
      elementFather.scrollLeft = actualLeft - element.clientWidth * 2;
    },
    showLine: function showLine() {
      if (this.isLineShow) {
        this.isLineShow = !this.isLineShow;
        this.mapObj.remove(this.curMarkerArr);
        this.mapObj.remove(this.polyline);
        this.polyline = null;
        this.curLinePoiIndex = -1;
        document.getElementById("linePois").scrollLeft = 0;

        this.addPoi();
      } else {
        this.isScenicPopShow = false;
        this.isLineShow = !this.isLineShow;

        this.mapObj.remove(this.curMarkerArr);
        this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
        this.mapObj.add(this.curMarkerArr);
        if (this.polyline == "" || this.polyline == undefined || this.polyline == null) {
          this.polyline = new AMap.Polyline({
            path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
            strokeColor: "#f56b61", //线颜色
            strokeOpacity: 0.8, //线透明度
            strokeWeight: 3, //线宽
            strokeStyle: "solid", //线样式
            isOutline: true,
            borderWeight: 1,
            outlineColor: "#fff",
            lineJoin: "round",
            lineCap: "round",
            strokeDasharray: [10, 5], //补充线样式
            zIndex: 9999
          });
          this.polyline.setMap(this.mapObj);
        } else {
          this.mapObj.remove(this.polyline);
        }
        this.mapObj.setFitView();
      }
    },
    changeLine: function changeLine(i) {
      if (i == this.lineIndex) {
        return;
      } else {
        this.lineIndex = i;
        this.curLinePoiIndex = -1;
        document.getElementById("linePois").scrollLeft = 0;
        this.mapObj.remove(this.curMarkerArr);
        if (this.polyline != null) {
          this.mapObj.remove(this.polyline);
          this.polyline = null;
        }
        this.polyline = new AMap.Polyline({
          path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
          strokeColor: "#f56b61", //线颜色
          strokeOpacity: 0.8, //线透明度
          strokeWeight: 3, //线宽
          strokeStyle: "solid", //线样式
          isOutline: true,
          borderWeight: 1,
          outlineColor: "#fff",
          lineJoin: "round",
          lineCap: "round",
          strokeDasharray: [10, 5], //补充线样式
          zIndex: 9999
        });
        this.polyline.setMap(this.mapObj);
        this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
        this.mapObj.add(this.curMarkerArr);
        this.mapObj.setFitView();
      }
    },
    changeCurLinePoiIndex: function changeCurLinePoiIndex(i) {
      if (i == this.curLinePoiIndex) {
        return;
      } else {
        this.curLinePoiIndex = i;
        var marker = this.lines[this.lineIndex].lineMarkers[i];
        marker.setTop(true);

        this.scrollLeftTo(document.getElementsByClassName("line-poi-item")[marker.getExtData().index], document.getElementById("linePois"), marker.getExtData().index);

        this.linePoiFun(marker.getExtData(), marker.getPosition());
      }
    },
    linePoiFun: function linePoiFun(data, position) {
      var that = this;
      console.log(data);
      console.log(position);
      that.lineVal.id = data.hid;

      this.mapObj.setCenter(position);

      if (document.getElementsByClassName("markerOn")[0] != undefined) {
        document.getElementsByClassName("markerOn")[0].classList.remove("markerOn");
      }
      var classVal = document.getElementById(data.domId).getAttribute("class");
      classVal = classVal.concat(" markerOn");
      document.getElementById(data.domId).setAttribute("class", classVal);
      var audio = document.getElementById("myaudio");
      that.audioSrc = that.GLOBAL.DOMAIN_URL + data.audio.split(".")[0] + ".mp3";
      audio.load();
      that.playing = false;
      this.barWidth = 0;
      this.dotLeft = 0;

      if (that.GLOBAL.isWx) {
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
            that.audioPlay();
          }, false);
        } else {
          document.addEventListener("WeixinJSBridgeReady", function () {
            WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
              that.audioPlay();
            });
          }, false);
        }
      } else {}

      document.getElementById(data.domId).getElementsByClassName("info-close")[0].addEventListener("touchstart", function () {
        that.curLinePoiIndex = -1;

        document.getElementsByClassName("markerOn")[0].classList.remove("markerOn");
      }, false);

      document.getElementById(data.domId).getElementsByClassName("info-go")[0].addEventListener("touchstart", function () {
        console.log("高德导航");
        var name = this.getAttribute("data-name");
        var lat = this.getAttribute("data-lat");
        var lng = this.getAttribute("data-lng");
        that.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
      }, false);

      document.getElementById(data.domId).getElementsByClassName("info-title-des")[0].addEventListener("touchstart", function () {
        that.openLineDetail();
      }, false);
    },
    setPoiType: function setPoiType(arr) {
      var that = this;
      that.poiType = [];
      for (var i in arr) {
        var obj = {};
        obj.id = arr[i].points_type_id;
        obj.name = arr[i].type_name;
        obj.defaultBg = arr[i].icon;
        obj.activeBg = arr[i].picth_icon;
        obj.poiDefaultBg = arr[i].point_icon;
        obj.poiActiveBg = arr[i].point_picth_icon;
        obj.poiArr = [];
        obj.isHasPoi = false;
        if (arr[i].points_type_id == 2) {
          that.activePoiTypeIndex = i;
        }
        for (var j = that.mapMinZoom; j <= that.mapMaxZoom; j++) {
          obj.poiArr.push([]);
        }
        that.poiType.push(obj);
      }
      console.log(that.poiType);
    },
    changePoiType: function changePoiType(typeId, i) {
      console.log("changePoiType");
      var that = this;

      if (this.isLineShow) {

        that.$vux.toast.text("请先退出线路", "bottom");
        return;
      } else {
        if (typeId == that.activePoiTypeId) {

          return;
        } else {
          that.mapObj.clearInfoWindow();
          that.activePoiTypeId = typeId;
          that.activePoiTypeIndex = i;
          that.mapObj.remove(this.curMarkerArr);
          that.addPoi();
          that.isScenicPopShow = false;
        }
      }
    },
    poiMarkerFun: function poiMarkerFun(data, position) {
      var that = this;
      if (data.poiData.type == 2) {

        that.$router.push({
          path: "/scenicPoiDetail",
          name: "scenicPoiDetail",
          query: { hid: data.poiData.hid }
        });
      } else {
        var distance = (this.commonFun.getGreatCircleDistance(sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), position.lat, position.lng) / 1000).toFixed(2);
        var title = "<img src='" + that.GLOBAL.DOMAIN_URL + data.default_type_bg + "' /><span>" + distance + "km</span>";

        var middle = "<div id='infoNav' data-name='" + data.poiData.chs_name + "' data-lat='" + position.lat + "' data-lng='" + position.lng + "'><i></i><span>到这里</span></div>";

        this.infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: this.createInfoWindow(title, middle),
          offset: new AMap.Pixel(0, -34)
        });
        this.infoWindow.open(this.mapObj, position);

        setTimeout(function () {
          that.mapObj.setCenter([position.lng, position.lat]);
          document.getElementById("infoNav").addEventListener("click", function () {
            console.log("高德导航");
            var name = this.getAttribute("data-name");
            var lat = this.getAttribute("data-lat");
            var lng = this.getAttribute("data-lng");
            that.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
          }, false);
        }, 50);
      }
    },
    createInfoWindow: function createInfoWindow(title, mContent) {
      var info = document.createElement("div");
      info.className = "content-window-card";

      var top = document.createElement("div");

      top.className = "info-top vux-1px-b";
      top.innerHTML = title;
      info.appendChild(top);

      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.innerHTML = mContent;
      info.appendChild(middle);

      return info;
    },
    addPoi: function addPoi() {

      this.curMarkerArr = this.poiType[this.activePoiTypeIndex].poiArr[this.mapObj.getZoom() - this.mapMinZoom];
      this.mapObj.add(this.curMarkerArr);
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      this.details = {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      }; //清空详情组件的details props
    },
    changeScenicPop: function changeScenicPop(val) {
      this.isScenicPopShow = val;
    },
    getScenicDetailFromScenicPop: function getScenicDetailFromScenicPop(val) {
      var that = this;

      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: val.id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = val.is_guide;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          for (var i in data.data.data.imgList) {
            details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
        }
      });
      this.isScenicPopShow = false;
      this.isDetailPopShow = true;
    },
    isPTListShow: function isPTListShow() {
      this.isPoiTypeListShow = !this.isPoiTypeListShow;
    },
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("myaudio");
      if (!audio.paused || audio.currentTime != 0) {

        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("myaudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft;
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft;

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    audioPlay: function audioPlay() {
      console.log("click");
      var that = this;
      var audio = document.getElementById("myaudio");

      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      if (audio.paused) {

        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    updateProgress: function updateProgress(audio) {
      console.log("同步进度条");
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
    },
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
    },
    openOutUrl: function openOutUrl(url) {
      window.location.href = url;
    }
  },

  created: function created() {
    this.getScenicData(this.hid);
  },
  mounted: function mounted() {
    console.log(this.$route.query);
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd77649c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/map.vue
var map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('audio',{attrs:{"id":"myaudio","src":_vm.audioSrc}}),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"container"}},[_c('ul',{staticClass:"left-btns"},[_c('li',{staticClass:"left-btn"},[_c('leLayer',{attrs:{"isLelayerShow":_vm.isLelayerShow,"leLayer":_vm.leLayer,"mapObj":_vm.mapObj,"activeImg":_vm.funImg.viewImgActive,"defaultImg":_vm.funImg.viewImgDefault}})],1),_vm._v(" "),_c('li',{staticClass:"left-btn",on:{"click":_vm.isPTListShow}},[_c('img',{attrs:{"src":_vm.isPoiTypeListShow?_vm.funImg.nearImgActive:_vm.funImg.nearImgDefault,"alt":""}})])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPoiTypeListShow),expression:"isPoiTypeListShow"}],staticClass:"poi-types"},_vm._l((_vm.poiType),function(item,index){return (item.isHasPoi)?_c('li',{key:index,class:['poi-type',_vm.activePoiTypeId==item.id?'active':''],on:{"click":function($event){return _vm.changePoiType(item.id,index)}}},[_c('img',{staticClass:"poi-type-icon",attrs:{"src":_vm.activePoiTypeId==item.id?(_vm.GLOBAL.DOMAIN_URL+item.activeBg):(_vm.GLOBAL.DOMAIN_URL+item.defaultBg)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_vm._e()}),0),_vm._v(" "),_c('ul',{staticClass:"right-btns"},[_c('li',{staticClass:"right-btn fun-search"},[_c('router-link',{attrs:{"to":"search"}},[_c('img',{attrs:{"src":_vm.funImg.searchImgDefault,"alt":""}})])],1),_vm._v(" "),(_vm.funImg.funFull.url!=''&&_vm.funImg.funFull.url!=null)?_c('li',{staticClass:"right-btn fun-full",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funFull.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funFull.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funShop.url!=''&&_vm.funImg.funShop.url!=null)?_c('li',{staticClass:"right-btn fun-shop",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funShop.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funShop.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funComplaint.url!=''&&_vm.funImg.funComplaint.url!=null)?_c('li',{staticClass:"right-btn fun-complaint",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funComplaint.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funComplaint.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funTicket.url!=''&&_vm.funImg.funTicket.url!=null)?_c('li',{staticClass:"right-btn fun-ticket",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funTicket.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funTicket.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funTraffic.url!=''&&_vm.funImg.funTraffic.url!=null)?_c('li',{staticClass:"right-btn fun-traffic",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funTraffic.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funTraffic.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funNotice.url!=''&&_vm.funImg.funNotice.url!=null)?_c('li',{staticClass:"right-btn fun-notice",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funNotice.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funNotice.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.funImg.funAct.url!=''&&_vm.funImg.funAct.url!=null)?_c('li',{staticClass:"right-btn fun-act",on:{"click":function($event){return _vm.openOutUrl(_vm.funImg.funAct.url)}}},[_c('img',{attrs:{"src":_vm.funImg.funAct.img,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.lines.length>0)?_c('li',{class:['right-btn fun-line',_vm.isLineShow?'on':''],on:{"click":_vm.showLine}},[_c('img',{attrs:{"src":_vm.isLineShow?_vm.funImg.lineImgActive:_vm.funImg.lineImgDefault,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('getLocation',{attrs:{"isLocation":_vm.isLocation,"scenicBound":_vm.scenicBound,"mapObj":_vm.mapObj,"activeImg":_vm.funImg.locationImgActive,"defaultImg":_vm.funImg.locationImgDefault,"id":"location"}})],1),_vm._v(" "),(_vm.lines.length>0)?_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"bottom","height":"170px","show-mask":false},model:{value:(_vm.isLineShow),callback:function ($$v) {_vm.isLineShow=$$v},expression:"isLineShow"}},[_c('div',{staticClass:"line-box"},[_c('div',{staticClass:"lines"},_vm._l((_vm.lines),function(item,index){return _c('div',{key:index,class:['line-name',_vm.lineIndex==index?'on':''],on:{"click":function($event){return _vm.changeLine(index)}}},[_vm._v(_vm._s(item.lineName))])}),0),_vm._v(" "),_c('div',{staticClass:"line-top-box"},[_c('div',{staticClass:"line-top-left"},[_c('div',{staticClass:"line-des ellipsis-1"},[_vm._v(_vm._s(_vm.lines[_vm.lineIndex].description))]),_vm._v(" "),_c('div',{staticClass:"line-num-time ellipsis-1"},[_vm._v(_vm._s(_vm.lines[_vm.lineIndex].scenicNum+" | "+_vm.lines[_vm.lineIndex].lineTime))])]),_vm._v(" "),(_vm.curLinePoiIndex!=-1)?_c('div',{staticClass:"line-poi-on"},[_c('div',{staticClass:"line-player"},[_c('div',{class:['progress-bar-bg',_vm.playing?'play':''],attrs:{"id":"progressBarBg"},on:{"mousedown":_vm.progressBarBg}},[_c('i',{style:('left:'+_vm.dotLeft+'%'),attrs:{"id":"progressDot"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.audioPlay($event)}}}),_vm._v(" "),_c('div',{staticClass:"progress-bar",style:('width:'+_vm.barWidth+'%'),attrs:{"id":"progressBar"}})])]),_vm._v(" "),_c('div',{staticClass:"go-detail",on:{"click":function($event){return _vm.openLineDetail()}}},[_c('span',[_vm._v("详情")]),_vm._v(" "),_c('i',{staticClass:"icon-more"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"line-pois",attrs:{"id":"linePois"}},_vm._l((_vm.lines[_vm.lineIndex].linePoiName),function(item,index){return _c('div',{key:index,class:['line-poi-item',_vm.curLinePoiIndex==index?'on':''],on:{"click":function($event){return _vm.changeCurLinePoiIndex(index)}}},[_c('div',{staticClass:"line-item-index"},[_c('div',{staticClass:"line-item-border"},[_vm._v(_vm._s(index+1))])]),_vm._v(" "),_c('div',{staticClass:"line-item-name ellipsis-1"},[_vm._v(_vm._s(item))])])}),0)])])],1):_vm._e(),_vm._v(" "),_c('detailPop',{attrs:{"isDetailPopShow":_vm.isDetailPopShow,"details":_vm.details},on:{"changeDetailShow":_vm.changeDetailPop}}),_vm._v(" "),_c('scenicPop',{attrs:{"isScenicPopShow":_vm.isScenicPopShow,"scenicPopData":_vm.scenicPopData,"isShowMask":false},on:{"changeScenicPopShow":_vm.changeScenicPop,"getScenicDetail":_vm.getScenicDetailFromScenicPop}})],1)}
var map_staticRenderFns = []
var map_esExports = { render: map_render, staticRenderFns: map_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_map = (map_esExports);
// CONCATENATED MODULE: ./src/pages/map.vue
function map_injectStyle (ssrContext) {
  __webpack_require__("E2Jw")
  __webpack_require__("Ljw+")
}
var map_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var map___vue_template_functional__ = false
/* styles */
var map___vue_styles__ = map_injectStyle
/* scopeId */
var map___vue_scopeId__ = "data-v-bd77649c"
/* moduleIdentifier (server only) */
var map___vue_module_identifier__ = null
var map_Component = map_normalizeComponent(
  pages_map,
  selectortype_template_index_0_src_pages_map,
  map___vue_template_functional__,
  map___vue_styles__,
  map___vue_scopeId__,
  map___vue_module_identifier__
)

/* harmony default export */ var src_pages_map = (map_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/specialList.vue
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var specialList = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    jumpTo: function jumpTo(url) {
      window.location.href = url;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = '专题导览';
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/specialList.vue
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var pages_specialList = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    jumpTo: function jumpTo(url) {
      window.location.href = url;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    document.title = '专题导览';
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29337361","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/specialList.vue
var specialList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"special-item",on:{"click":function($event){return _vm.jumpTo('http://jx.worldmaipu.com/jxMap/red/map.html')}}},[_vm._v("红色旅游专题")]),_vm._v(" "),_c('div',{staticClass:"special-item",on:{"click":function($event){return _vm.jumpTo('http://daoyou.worldmaipu.com/upload_resource/2019/project/sdsl/loading.html')}}},[_vm._v("四大诗路专题")]),_vm._v(" "),_c('div',{staticClass:"special-item",on:{"click":function($event){return _vm.jumpTo('http://daoyou.worldmaipu.com/upload_resource/2018/project/putuo/map.html')}}},[_vm._v("海洋海岛旅游专题")])])}
var specialList_staticRenderFns = []
var specialList_esExports = { render: specialList_render, staticRenderFns: specialList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_specialList = (specialList_esExports);
// CONCATENATED MODULE: ./src/pages/specialList.vue
function specialList_injectStyle (ssrContext) {
  __webpack_require__("1I+l")
}
var specialList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var specialList___vue_template_functional__ = false
/* styles */
var specialList___vue_styles__ = specialList_injectStyle
/* scopeId */
var specialList___vue_scopeId__ = "data-v-29337361"
/* moduleIdentifier (server only) */
var specialList___vue_module_identifier__ = null
var specialList_Component = specialList_normalizeComponent(
  pages_specialList,
  selectortype_template_index_0_src_pages_specialList,
  specialList___vue_template_functional__,
  specialList___vue_styles__,
  specialList___vue_scopeId__,
  specialList___vue_module_identifier__
)

/* harmony default export */ var src_pages_specialList = (specialList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bxqw.vue








/* harmony default export */ var bxqw = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    getLocation: src_components_getLocation,
    XImg: vux_src_components_x_img,
    detailPop: src_components_detailPop
  },
  data: function data() {

    return {

      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      plateId: this.$route.query.plateId,
      mapObj: null, //地图实例
      geocoder: null, //地理/逆地理编码插件
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //景区电子围栏范围
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      mapLat: 30.244132,
      mapLng: 120.147476,
      leLayer: null, //瓦片
      areaList: null,
      adCode: 3300, //高德的adCode 浙江省3300 用于是否要切换景区时做判断

      dataList: null,
      curMarkerArr: [],
      isBarShow: false,
      provinceMarkers: [], //省级聚合点
      citysMarkers: [],
      cityPolygons: [], //市级行政区域范围
      moveStartZoom: null, //平移开始时的地图层级
      moveEndZoom: null
    };
  },


  computed: {},

  watch: {
    adCode: function adCode(newV) {
      var i = void 0;
      if (newV == "3300") {
        i = 0;
      } else {
        for (var j in this.areaList) {
          if (newV == this.areaList[j].adCode) {
            i = parseInt(j) + 1;
            break;
          }
        }
      }
      console.log("iiiiiiiiiiiii=" + i);

      this.scrollLeftTo(document.getElementsByClassName("bar-item")[i], document.getElementById("barBox"), i);
    }
  },

  methods: {
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.mapLng, that.mapLat),
          zoom: 7, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });
      that.curMarkerArr = that.provinceMarkers;
      that.mapObj.add(that.curMarkerArr);

      that.isLocation = true;
      that.mapObj.on("complete", function () {});

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      AMap.event.addListener(that.mapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.mapObj.getZoom());
      });

      AMap.event.addListener(that.mapObj, "movestart", function () {
        that.moveStartZoom = that.mapObj.getZoom();
        console.log("moveStart............zoom:" + that.moveStartZoom);
      });

      AMap.event.addListener(that.mapObj, "moveend", function () {
        that.moveEndZoom = that.mapObj.getZoom();
        console.log("moveEnd............zoom:" + that.moveEndZoom);
        that.geocoder.getAddress([that.mapObj.getCenter().lng, that.mapObj.getCenter().lat], function (status, result) {
          if (status === "complete" && result.info === "OK") {

            console.log(result);

            var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);
            console.log(cityCode + "..." + that.adCode);
            if (that.moveEndZoom != that.moveStartZoom) {

              console.log("平移后缩放了");
              that.zoomAndMove(cityCode);
            } else {

              console.log("平移后没缩放");
              that.justMove(cityCode);
            }

            if (that.mapObj.getZoom() < 9) {

              that.mapObj.remove(that.cityPolygons);
            } else {

              if (cityCode.substring(0, 2) == "33") {
                AMap.plugin("AMap.DistrictSearch", function () {

                  var district = new AMap.DistrictSearch({

                    extensions: "all",

                    level: "city"
                  });

                  district.search(result.regeocode.addressComponent.citycode, function (status, result) {

                    var bounds = result.districtList[0].boundaries;
                    that.mapObj.remove(that.cityPolygons);
                    that.cityPolygons = [];
                    if (bounds) {
                      for (var i = 0, l = bounds.length; i < l; i++) {

                        var polygon = new AMap.Polygon({
                          map: that.mapObj,
                          strokeWeight: 2,
                          path: bounds[i],
                          fillOpacity: 0,

                          strokeColor: "#48636e"
                        });
                        that.cityPolygons.push(polygon);
                      }
                    }
                  });
                });
              }
            }
          }
        });
      });

      that.mapObj.plugin("AMap.Geocoder", function () {
        that.geocoder = new AMap.Geocoder({

          city: "浙江省",
          extensions: "base"
        });
      });
    },
    getCityAndTags: function getCityAndTags() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialFilter.action",
        params: {
          type: that.plateId
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.areaList = data.data.data.areaList;
          that.citysId = data.data.data.areaList[0].id;
          that.getData(that.citysId);
        }
      });
    },
    getData: function getData() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialData.action",
        params: {
          type: that.plateId,
          area_id: that.citysId,
          tag_id: -1
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.dataList = data.data.data.specialList;
          that.mapObj.remove(that.curMarkerArr);
          that.curMarkerArr = [];
          if (that.dataList.length == 0) {
            that.$vux.toast.text("暂无数据", "middle");
          } else {
            that.setMarker(that.dataList);
            that.mapObj.add(that.curMarkerArr);
          }
        }
      });
    },
    setMarker: function setMarker(points) {
      var that = this;
      for (var i in points) {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(points[i].longitude_gcj, points[i].latitude_gcj),

          content: '<div class=\'citys-poi\'><div class=\'ua_poi\'></div><span class=\'ua_poi_name\'>' + points[i].name + '</span></div>',

          offset: new AMap.Pixel(-16, -32),
          extData: {
            id: points[i].id
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);

          that.getDetail(extData.id);
        });
        var min = points[i].min_zoom - 9;
        for (var z = 0; z < that.mapMaxZoom - 9 + 1; z++) {
          if (z >= min) {
            that.citysMarkers[z].push(marker);
          }
        }
      }
      console.log(that.citysMarkers);
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      if (val == false) {
        this.details = {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false,
          id: ""
        }; //清空详情组件的details props
      }
    },
    changeCity: function changeCity(adCode, lat, lng) {
      if (this.adCode == adCode) {
        return;
      } else {

        if (adCode == "3300") {
          this.adCode = "3300";
          if (this.mapObj.getZoom() < 9) {} else {
            this.mapObj.setZoom(7);
          }

          this.mapObj.remove(this.cityPolygons);

          this.mapObj.remove(this.curMarkerArr);
          this.curMarkerArr = this.provinceMarkers;
          this.mapObj.add(this.curMarkerArr);
        } else {
          this.mapObj.setCenter([lng, lat]);
          if (this.mapObj.getZoom() < 9) {
            this.adCode = adCode;
            this.getDatas(this.adCode);
          }
        }
      }
    },
    getDatas: function getDatas(adCode) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getFood.action",
        params: {
          adCode: adCode
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.dataList = data.data.data.foodList;
          if (that.areaList == null) {

            that.areaList = data.data.data.areaList;
            for (var i in that.areaList) {
              var marker = new AMap.Marker({

                content: "<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" + that.areaList[i].name + "</span><i>" + that.areaList[i].counts + "</i>" + "</span></div>",
                position: new AMap.LngLat(that.areaList[i].longitude_gcj, that.areaList[i].latitude_gcj),

                offset: new AMap.Pixel(-10, -32), //中心点


                extData: {
                  citysId: that.areaList[i].id
                }
              });
              AMap.event.addListener(marker, "click", function (e) {
                var position = e.target.getPosition();
                var extData = e.target.getExtData();
                this.setTop(true);
                console.log(extData);
                that.citysId = extData.citysId;

                that.mapObj.setZoomAndCenter(9, position);
              });
              that.provinceMarkers.push(marker);
            }
          } else {}

          if (that.mapObj == null) {

            that.getMap();
          } else {}

          if (that.mapObj.getZoom() > 8) {
            that.citysMarkers = [];
            for (var j = 9; j < that.mapMaxZoom + 1; j++) {
              that.citysMarkers.push([]);
            }
            that.setMarker(that.dataList);
            that.mapObj.remove(that.curMarkerArr);
            that.curMarkerArr = that.citysMarkers[that.mapObj.getZoom() - 9];
            that.mapObj.add(that.curMarkerArr);
          }
        }
      });
    },
    getDetail: function getDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = 0;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          if (data.data.data.imgList.length != 0) {
            for (var i in data.data.data.imgList) {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
            }
          } else {
            if (data.data.data.hotspot.thumbImg.indexOf("http") != -1) {
              details.imgList.push(data.data.data.hotspot.thumbImg);
            } else {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.thumbImg);
            }
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
          that.isDetailPopShow = true;
        }
      });
    },
    justMove: function justMove(cityCode) {
      var that = this;
      if (cityCode.substring(0, 2) == "33") {

        console.log("浙江省内");

        if (that.mapObj.getZoom() < 9) {

          return;
        } else {
          if (cityCode == that.adCode) {

            return;
          } else {

            that.adCode = cityCode;
            that.getDatas(that.adCode);
          }
        }
      } else {
        console.log("浙江省外");

        return;
      }
    },
    zoomAndMove: function zoomAndMove(cityCode) {
      var that = this;
      var zoom = that.mapObj.getZoom();
      if (cityCode.substring(0, 2) == "33") {

        console.log("浙江省内");
        if (zoom < 9) {
          that.adCode = "3300";

          that.mapObj.remove(that.curMarkerArr);
          that.curMarkerArr = that.provinceMarkers;
          that.mapObj.add(that.curMarkerArr);
        } else {
          if (cityCode == that.adCode) {

            that.mapObj.remove(that.curMarkerArr);
            that.curMarkerArr = that.citysMarkers[zoom - 9];
            that.mapObj.add(that.curMarkerArr);
          } else {

            that.adCode = cityCode;
            that.getDatas(that.adCode);
          }
        }
      } else {

        console.log("浙江省外");
        return;
      }
    },
    scrollLeftTo: function scrollLeftTo(element, elementFather, index) {
      var actualLeft = element.offsetLeft;
      var current = element.offsetParent;
      actualLeft += current.offsetLeft;
      current = current.offsetParent;
      elementFather.scrollLeft = actualLeft - element.clientWidth * 1;
    }
  },

  created: function created() {
    document.title = "百县千碗";

    this.getDatas(this.adCode);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bxqw.vue








/* harmony default export */ var pages_bxqw = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    getLocation: src_components_getLocation,
    XImg: vux_src_components_x_img,
    detailPop: src_components_detailPop
  },
  data: function data() {

    return {

      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      },

      plateId: this.$route.query.plateId,
      mapObj: null, //地图实例
      geocoder: null, //地理/逆地理编码插件
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //景区电子围栏范围
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      mapLat: 30.244132,
      mapLng: 120.147476,
      leLayer: null, //瓦片
      areaList: null,
      adCode: 3300, //高德的adCode 浙江省3300 用于是否要切换景区时做判断

      dataList: null,
      curMarkerArr: [],
      isBarShow: false,
      provinceMarkers: [], //省级聚合点
      citysMarkers: [],
      cityPolygons: [], //市级行政区域范围
      moveStartZoom: null, //平移开始时的地图层级
      moveEndZoom: null
    };
  },


  computed: {},

  watch: {
    adCode: function adCode(newV) {
      var i = void 0;
      if (newV == "3300") {
        i = 0;
      } else {
        for (var j in this.areaList) {
          if (newV == this.areaList[j].adCode) {
            i = parseInt(j) + 1;
            break;
          }
        }
      }
      console.log("iiiiiiiiiiiii=" + i);

      this.scrollLeftTo(document.getElementsByClassName("bar-item")[i], document.getElementById("barBox"), i);
    }
  },

  methods: {
    getMap: function getMap() {
      var that = this;

      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.mapLng, that.mapLat),
          zoom: 7, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });
      that.curMarkerArr = that.provinceMarkers;
      that.mapObj.add(that.curMarkerArr);

      that.isLocation = true;
      that.mapObj.on("complete", function () {});

      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      AMap.event.addListener(that.mapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.mapObj.getZoom());
      });

      AMap.event.addListener(that.mapObj, "movestart", function () {
        that.moveStartZoom = that.mapObj.getZoom();
        console.log("moveStart............zoom:" + that.moveStartZoom);
      });

      AMap.event.addListener(that.mapObj, "moveend", function () {
        that.moveEndZoom = that.mapObj.getZoom();
        console.log("moveEnd............zoom:" + that.moveEndZoom);
        that.geocoder.getAddress([that.mapObj.getCenter().lng, that.mapObj.getCenter().lat], function (status, result) {
          if (status === "complete" && result.info === "OK") {

            console.log(result);

            var cityCode = result.regeocode.addressComponent.adcode.substring(0, 4);
            console.log(cityCode + "..." + that.adCode);
            if (that.moveEndZoom != that.moveStartZoom) {

              console.log("平移后缩放了");
              that.zoomAndMove(cityCode);
            } else {

              console.log("平移后没缩放");
              that.justMove(cityCode);
            }

            if (that.mapObj.getZoom() < 9) {

              that.mapObj.remove(that.cityPolygons);
            } else {

              if (cityCode.substring(0, 2) == "33") {
                AMap.plugin("AMap.DistrictSearch", function () {

                  var district = new AMap.DistrictSearch({

                    extensions: "all",

                    level: "city"
                  });

                  district.search(result.regeocode.addressComponent.citycode, function (status, result) {

                    var bounds = result.districtList[0].boundaries;
                    that.mapObj.remove(that.cityPolygons);
                    that.cityPolygons = [];
                    if (bounds) {
                      for (var i = 0, l = bounds.length; i < l; i++) {

                        var polygon = new AMap.Polygon({
                          map: that.mapObj,
                          strokeWeight: 2,
                          path: bounds[i],
                          fillOpacity: 0,

                          strokeColor: "#48636e"
                        });
                        that.cityPolygons.push(polygon);
                      }
                    }
                  });
                });
              }
            }
          }
        });
      });

      that.mapObj.plugin("AMap.Geocoder", function () {
        that.geocoder = new AMap.Geocoder({

          city: "浙江省",
          extensions: "base"
        });
      });
    },
    getCityAndTags: function getCityAndTags() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialFilter.action",
        params: {
          type: that.plateId
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.areaList = data.data.data.areaList;
          that.citysId = data.data.data.areaList[0].id;
          that.getData(that.citysId);
        }
      });
    },
    getData: function getData() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialData.action",
        params: {
          type: that.plateId,
          area_id: that.citysId,
          tag_id: -1
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.dataList = data.data.data.specialList;
          that.mapObj.remove(that.curMarkerArr);
          that.curMarkerArr = [];
          if (that.dataList.length == 0) {
            that.$vux.toast.text("暂无数据", "middle");
          } else {
            that.setMarker(that.dataList);
            that.mapObj.add(that.curMarkerArr);
          }
        }
      });
    },
    setMarker: function setMarker(points) {
      var that = this;
      for (var i in points) {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(points[i].longitude_gcj, points[i].latitude_gcj),

          content: '<div class=\'citys-poi\'><div class=\'ua_poi\'></div><span class=\'ua_poi_name\'>' + points[i].name + '</span></div>',

          offset: new AMap.Pixel(-16, -32),
          extData: {
            id: points[i].id
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          var position = e.target.getPosition();
          var extData = e.target.getExtData();
          this.setTop(true);
          console.log(extData);

          that.getDetail(extData.id);
        });
        var min = points[i].min_zoom - 9;
        for (var z = 0; z < that.mapMaxZoom - 9 + 1; z++) {
          if (z >= min) {
            that.citysMarkers[z].push(marker);
          }
        }
      }
      console.log(that.citysMarkers);
    },
    changeDetailPop: function changeDetailPop(val) {
      this.isDetailPopShow = val;
      if (val == false) {
        this.details = {
          imgList: [],
          title: "",
          address: "",
          des: "",
          mobile: "",
          lat: "",
          lng: "",
          is_guide: false,
          id: ""
        }; //清空详情组件的details props
      }
    },
    changeCity: function changeCity(adCode, lat, lng) {
      if (this.adCode == adCode) {
        return;
      } else {

        if (adCode == "3300") {
          this.adCode = "3300";
          if (this.mapObj.getZoom() < 9) {} else {
            this.mapObj.setZoom(7);
          }

          this.mapObj.remove(this.cityPolygons);

          this.mapObj.remove(this.curMarkerArr);
          this.curMarkerArr = this.provinceMarkers;
          this.mapObj.add(this.curMarkerArr);
        } else {
          this.mapObj.setCenter([lng, lat]);
          if (this.mapObj.getZoom() < 9) {
            this.adCode = adCode;
            this.getDatas(this.adCode);
          }
        }
      }
    },
    getDatas: function getDatas(adCode) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getFood.action",
        params: {
          adCode: adCode
        },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          that.dataList = data.data.data.foodList;
          if (that.areaList == null) {

            that.areaList = data.data.data.areaList;
            for (var i in that.areaList) {
              var marker = new AMap.Marker({

                content: "<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" + that.areaList[i].name + "</span><i>" + that.areaList[i].counts + "</i>" + "</span></div>",
                position: new AMap.LngLat(that.areaList[i].longitude_gcj, that.areaList[i].latitude_gcj),

                offset: new AMap.Pixel(-10, -32), //中心点


                extData: {
                  citysId: that.areaList[i].id
                }
              });
              AMap.event.addListener(marker, "click", function (e) {
                var position = e.target.getPosition();
                var extData = e.target.getExtData();
                this.setTop(true);
                console.log(extData);
                that.citysId = extData.citysId;

                that.mapObj.setZoomAndCenter(9, position);
              });
              that.provinceMarkers.push(marker);
            }
          } else {}

          if (that.mapObj == null) {

            that.getMap();
          } else {}

          if (that.mapObj.getZoom() > 8) {
            that.citysMarkers = [];
            for (var j = 9; j < that.mapMaxZoom + 1; j++) {
              that.citysMarkers.push([]);
            }
            that.setMarker(that.dataList);
            that.mapObj.remove(that.curMarkerArr);
            that.curMarkerArr = that.citysMarkers[that.mapObj.getZoom() - 9];
            that.mapObj.add(that.curMarkerArr);
          }
        }
      });
    },
    getDetail: function getDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
        params: { hid: id },
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data.data);
          var details = {};
          details.is_guide = 0;
          details.id = data.data.data.hotspot.id;
          details.imgList = [];
          if (data.data.data.imgList.length != 0) {
            for (var i in data.data.data.imgList) {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg);
            }
          } else {
            if (data.data.data.hotspot.thumbImg.indexOf("http") != -1) {
              details.imgList.push(data.data.data.hotspot.thumbImg);
            } else {
              details.imgList.push(that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.thumbImg);
            }
          }

          details.title = data.data.data.hotspot.name;
          details.address = data.data.data.hotspot.address;
          details.des = data.data.data.hotspot.description;
          details.mobile = "";
          details.lat = data.data.data.hotspot.latitudeGCJ + "";
          details.lng = data.data.data.hotspot.longitudeGCJ + "";
          if (data.data.data.hotspot.audio != null) {
            details.audio = that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.audio.split(".")[0] + ".mp3";
          }

          that.details = details;
          that.isDetailPopShow = true;
        }
      });
    },
    justMove: function justMove(cityCode) {
      var that = this;
      if (cityCode.substring(0, 2) == "33") {

        console.log("浙江省内");

        if (that.mapObj.getZoom() < 9) {

          return;
        } else {
          if (cityCode == that.adCode) {

            return;
          } else {

            that.adCode = cityCode;
            that.getDatas(that.adCode);
          }
        }
      } else {
        console.log("浙江省外");

        return;
      }
    },
    zoomAndMove: function zoomAndMove(cityCode) {
      var that = this;
      var zoom = that.mapObj.getZoom();
      if (cityCode.substring(0, 2) == "33") {

        console.log("浙江省内");
        if (zoom < 9) {
          that.adCode = "3300";

          that.mapObj.remove(that.curMarkerArr);
          that.curMarkerArr = that.provinceMarkers;
          that.mapObj.add(that.curMarkerArr);
        } else {
          if (cityCode == that.adCode) {

            that.mapObj.remove(that.curMarkerArr);
            that.curMarkerArr = that.citysMarkers[zoom - 9];
            that.mapObj.add(that.curMarkerArr);
          } else {

            that.adCode = cityCode;
            that.getDatas(that.adCode);
          }
        }
      } else {

        console.log("浙江省外");
        return;
      }
    },
    scrollLeftTo: function scrollLeftTo(element, elementFather, index) {
      var actualLeft = element.offsetLeft;
      var current = element.offsetParent;
      actualLeft += current.offsetLeft;
      current = current.offsetParent;
      elementFather.scrollLeft = actualLeft - element.clientWidth * 1;
    }
  },

  created: function created() {
    document.title = "百县千碗";

    this.getDatas(this.adCode);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f655932e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bxqw.vue
var bxqw_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container",attrs:{"id":"container"}}),_vm._v(" "),_c('getLocation',{attrs:{"isLocation":_vm.isLocation,"scenicBound":_vm.scenicBound,"mapObj":_vm.mapObj,"activeImg":"https://daoyou.worldmaipu.com/upload_resource/tag/icon/2019/1203/20191203162432UJ8C2QRYFFZJVK68H5CS.png","defaultImg":"https://daoyou.worldmaipu.com/upload_resource/tag/icon/2019/1203/201912031620485TWSKV88ENZ4RRDUZ6WO.png","id":"location"}}),_vm._v(" "),_c('div',{class:['poi-type-bar',_vm.isBarShow?'show':'']},[_c('div',{staticClass:"type-bars"},[_c('div',{staticClass:"bar-box",attrs:{"id":"barBox"}},[_c('div',{class:['bar-item',_vm.adCode=='3300'?'active':''],on:{"click":function($event){return _vm.changeCity('3300',_vm.mapLat,_vm.mapLng)}}},[_vm._v("全省")]),_vm._v(" "),_vm._l((_vm.areaList),function(item,index){return _c('div',{key:index,class:['bar-item',_vm.adCode==item.adCode?'active':''],on:{"click":function($event){return _vm.changeCity(item.adCode,item.latitude_gcj,item.longitude_gcj)}}},[_vm._v(_vm._s(item.name))])})],2),_vm._v(" "),_c('div',{class:['up-dowm',_vm.isBarShow?'up':'down'],on:{"click":function($event){_vm.isBarShow=!_vm.isBarShow}}})]),_vm._v(" "),_c('div',{staticClass:"result-box",attrs:{"id":"list"}},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"result-item",on:{"click":function($event){return _vm.getDetail(item.id)}}},[_c('x-img',{staticClass:"result-pic",attrs:{"src":(item.thumb_img.indexOf('http')==-1?(_vm.GLOBAL.DOMAIN_URL+item.thumb_img):item.thumb_img),"webp-src":item.cover_img,"offset":400,"container":"#list"}}),_vm._v(" "),_c('div',{staticClass:"result-right"},[_c('div',{staticClass:"result-item-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"result-item-address"},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',{staticClass:"ellipsis-2"},[_vm._v(_vm._s(item.address))])])])],1)}),0)]),_vm._v(" "),_c('detailPop',{attrs:{"isDetailPopShow":_vm.isDetailPopShow,"details":_vm.details},on:{"changeDetailShow":_vm.changeDetailPop}})],1)}
var bxqw_staticRenderFns = []
var bxqw_esExports = { render: bxqw_render, staticRenderFns: bxqw_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_bxqw = (bxqw_esExports);
// CONCATENATED MODULE: ./src/pages/bxqw.vue
function bxqw_injectStyle (ssrContext) {
  __webpack_require__("Ssmd")
}
var bxqw_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bxqw___vue_template_functional__ = false
/* styles */
var bxqw___vue_styles__ = bxqw_injectStyle
/* scopeId */
var bxqw___vue_scopeId__ = "data-v-f655932e"
/* moduleIdentifier (server only) */
var bxqw___vue_module_identifier__ = null
var bxqw_Component = bxqw_normalizeComponent(
  pages_bxqw,
  selectortype_template_index_0_src_pages_bxqw,
  bxqw___vue_template_functional__,
  bxqw___vue_styles__,
  bxqw___vue_scopeId__,
  bxqw___vue_module_identifier__
)

/* harmony default export */ var src_pages_bxqw = (bxqw_Component.exports);

// CONCATENATED MODULE: ./src/router/Index.js











vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router_Index = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: function redirect() {
      return '/index';
    }
  }, {
    path: '/index',
    name: 'index',
    component: src_pages_Index
  },
  // {
  //   path: '/',
  //   name: 'scenicPoiDetail',
  //   component: ScenicPoiDetail
  // },

  // {
  //   path: '/',
  //   name: 'map',
  //   component: Map
  // },
  {
    path: '/map',
    name: 'map',
    component: src_pages_map
  }, {
    path: '/toilet',
    name: 'toilet',
    component: src_pages_toilet
  }, {
    path: '/search',
    name: 'search',
    component: src_pages_search
  }, {
    path: '/scenicPoiDetail',
    name: 'scenicPoiDetail',
    component: src_pages_scenicPoiDetail
  }, {
    path: '/specialList',
    name: 'specialList',
    component: src_pages_specialList
  }, {
    path: '/bxqw',
    name: 'bxqw',
    component: src_pages_bxqw
  }]
}));
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/sha1/sha1.js
var sha1 = __webpack_require__("uXeI");
var sha1_default = /*#__PURE__*/__webpack_require__.n(sha1);

// CONCATENATED MODULE: ./src/assets/utils/wx.js






vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(ajax["a" /* default */]);

/* harmony default export */ var wx = ({

  wxShare: function wxShare(obj, callback) {
    console.log(obj, callback);
    if (obj) {
      var title = obj.title == undefined || obj.title == null ? '测试系统' : obj.title;
      var link = obj.link == undefined || obj.link == null ? window.location.href : obj.link;
      var desc = obj.desc == undefined || obj.desc == null ? '测试系统' : obj.desc;
      var imgUrl = obj.imgUrl == undefined || obj.imgUrl == null ? 'src/img/share.png' : obj.imgUrl;
    } else {
      alert('请传分享参数');
    }

    vue_esm["a" /* default */].wechat.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接
      desc: desc, // 分享描述
      imgUrl: imgUrl, // 分享图标
      success: function success() {
        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareQZone({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });
  },
  wxConfig: function wxConfig(isDebug, shareObj, callback) {
    function getUrl() {
      var url = window.location.href;

      var locationurl = url.split('#')[0];

      console.log(locationurl);

      return locationurl;
    }
    console.log(isDebug);

    vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.GLOBAL.BASE_URL + "/api/v1/index!getTokenAndTicket.action?appid=wxfc93a7b56a54e5c0").then(function (response) {
      return response.data.data;
    }).then(function (data) {
      console.log('微信微信', data);
      var ret = {
        'appId': 'wxfc93a7b56a54e5c0',
        "timestamp": parseInt(new Date().getTime() / 1000),
        "nonceStr": Math.random().toString(36).substr(2),
        "jsapi_ticket": data.tokenAndTicket.ticket,
        "signature": '',
        "url": getUrl()
      };
      var string = "jsapi_ticket=" + ret.jsapi_ticket + "&noncestr=" + ret.nonceStr + "&timestamp=" + ret.timestamp + "&url=" + ret.url;
      ret.signature = sha1_default()(string);

      var wxdata = {
        'debug': isDebug,
        'appId': ret.appId,
        "timestamp": ret.timestamp,
        "nonceStr": ret.nonceStr,
        "jsapi_ticket": ret.jsapi_ticket,
        "signature": ret.signature,
        "url": ret.url,
        'jsApiList': ['getLocation', "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"]
      };

      console.log(wxdata);

      vue_esm["a" /* default */].wechat.config(wxdata);
      vue_esm["a" /* default */].wechat.ready(function () {

        vue_esm["a" /* default */].wechat.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            console.log("在小程序里");
            sessionStorage.setItem('isSP', 'true');
          } else {
            sessionStorage.setItem('isSP', 'false');
            console.log("不在小程序里");
          }
        });
        vue_esm["a" /* default */].wechat.onMenuShareTimeline({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {
            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareAppMessage({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareQQ({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareQZone({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareWeibo({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });
        vue_esm["a" /* default */].wechat.getLocation({
          type: 'gcj02', // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
          success: function success(res) {

            console.log('获取微信定位成功！');

            sessionStorage.setItem("lat", res.latitude);
            sessionStorage.setItem("lng", res.longitude);
          }
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//

// import vueTouch from "@/assets/utils/vueTouch.js";

/* harmony default export */ var App = ({
  name: "app",
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created: function created() {
    // 微信jssdk 配置
    wx.wxConfig(false, {
      title: "诗画浙江全域导览", // 分享标题
      link: window.location.href, // 分享链接
      desc: window.location.href, // 分享描述
      imgUrl: "" // 分享图标
    }, function () {
      //分享成功后的回调函数
      console.log("分享成功");
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//

// import vueTouch from "@/assets/utils/vueTouch.js";

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created: function created() {
    // 微信jssdk 配置
    wx.wxConfig(false, {
      title: "诗画浙江全域导览", // 分享标题
      link: window.location.href, // 分享链接
      desc: window.location.href, // 分享描述
      imgUrl: "" // 分享图标
    }, function () {
      //分享成功后的回调函数
      console.log("分享成功");
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96536658","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("wwxo")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// CONCATENATED MODULE: ./src/assets/utils/commonFun.js


/* harmony default export */ var commonFun = ({

  getGreatCircleDistance: function getGreatCircleDistance(lat1, lng1, lat2, lng2) {
    var EARTH_RADIUS = 6378137.0;
    var PI = Math.PI;

    function getRad(d) {
      return d * PI / 180.0;
    }
    var radLat1 = getRad(lat1);
    var radLat2 = getRad(lat2);

    var a = radLat1 - radLat2;
    var b = getRad(lng1) - getRad(lng2);

    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;

    return s;
  },

  openLocation: function openLocation(name, lat1, lng1, lat2, lng2) {

    if (vue_esm["a" /* default */].prototype.GLOBAL.isWx) {
      vue_esm["a" /* default */].prototype.$wechat.openLocation({
        latitude: Number(lat2), // 纬度，范围为-90~90，负数表示南纬
        longitude: Number(lng2), // 经度，范围为-180~180，负数表示西经
        scale: 28, // 缩放比例
        name: name, // 位置名

        success: function success(res) {},
        fail: function fail() {},
        complete: function complete() {}
      });
    } else {

      var url = "http://uri.amap.com/navigation//uri.amap.com/navigation?from=" + lng2 + "," + lat2 + ",我的位置&to=" + lng1 + "," + lat1 + "," + name + "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0";
      window.location.href = url;
    }
  },
  getCookie: function getCookie(c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  setCookie: function setCookie(name, value, time) {
    if (arguments.length == 2) {
      var Days = 7;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + escape(value) + "; expires=" + exp.toGMTString();
    } else {
      var strsec = getsec(time);
      var _exp = new Date();
      _exp.setTime(_exp.getTime() + strsec * 1);
      document.cookie = name + "=" + escape(value) + ";expires=" + _exp.toGMTString();
    }
  },
  getsec: function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else {
      if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
      } else {
        if (str2 == "d") {
          return str1 * 24 * 60 * 60 * 1000;
        }
      }
    }
  },
  GetQueryString: function GetQueryString(name) {
    var url = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var newUrl = window.location.search.substr(1).match(url);
    if (newUrl != null) {
      return unescape(newUrl[2]);
    } else {
      return false;
    }
  },
  getUrlCode: function getUrlCode() {
    // 截取url中的code方法
    var url = location.search;
    this.winUrl = url;
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
    return theRequest;
  },

  /**
  * 音频播放时间换算
  * @param {number} value - 音频当前播放时间，单位秒
  */
  transTime: function transTime(value) {
    var time = "";
    var h = parseInt(value / 3600);
    value %= 3600;
    var m = parseInt(value / 60);
    var s = parseInt(value % 60);
    if (h > 0) {
      time = this.formatTime(h + ":" + m + ":" + s);
    } else {
      time = this.formatTime(m + ":" + s);
    }

    return time;
  },


  /**
  * 格式化时间显示，补零对齐
  * eg：2:4  -->  02:04
  * @param {string} value - 形如 h:m:s 的字符串
  */
  formatTime: function formatTime(value) {
    var time = "";
    var s = value.split(':');
    var i = 0;
    for (; i < s.length - 1; i++) {
      time += s[i].length == 1 ? "0" + s[i] : s[i];
      time += ":";
    }
    time += s[i].length == 1 ? "0" + s[i] : s[i];

    return time;
  },
  trim: function trim(string) {
    return string.replace(/(^\s*)|(\s*$)/g, '');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  BASE_URL = "https://dy.worldmaipu.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  BASE_URL = "/api";
}
var DOMAIN_URL = "https://daoyou.worldmaipu.com/"; //资源域名地址

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var isWx = u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

/* harmony default export */ var global = ({
  BASE_URL: BASE_URL, //接口地址
  DOMAIN_URL: DOMAIN_URL, //静态文件域名
  isAndroid: isAndroid, //是否在安卓
  isIos: isIos, //是否在ios
  isWx: isWx, //是否在微信
  isPc: isPc //是否在pc
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var global_BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  global_BASE_URL = "https://dy.worldmaipu.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  global_BASE_URL = "/api";
}
var global_DOMAIN_URL = "https://daoyou.worldmaipu.com/"; //资源域名地址

var global_u = navigator.userAgent;
var global_isAndroid = global_u.indexOf("Android") > -1 || global_u.indexOf("Adr") > -1; //android终端
var global_isIos = !!global_u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var global_isWx = global_u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var global_isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

/* harmony default export */ var components_global = ({
  BASE_URL: global_BASE_URL, //接口地址
  DOMAIN_URL: global_DOMAIN_URL, //静态文件域名
  isAndroid: global_isAndroid, //是否在安卓
  isIos: global_isIos, //是否在ios
  isWx: global_isWx, //是否在微信
  isPc: global_isPc //是否在pc
});
// CONCATENATED MODULE: ./src/components/global.vue
var global_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var global___vue_template_functional__ = false
/* styles */
var global___vue_styles__ = null
/* scopeId */
var global___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var global___vue_module_identifier__ = null
var global_Component = global_normalizeComponent(
  components_global,
  __vue_template__,
  global___vue_template_functional__,
  global___vue_styles__,
  global___vue_scopeId__,
  global___vue_module_identifier__
)

/* harmony default export */ var src_components_global = (global_Component.exports);

// CONCATENATED MODULE: ./src/main.js















vue_esm["a" /* default */].prototype.commonFun = commonFun;
/**

* 加载插件

*/
vue_esm["a" /* default */].use(animate_default.a);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);

vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(router_Index);

/**
* 定义常量 变量
*/


vue_esm["a" /* default */].prototype.GLOBAL = src_components_global;
console.log(vue_esm["a" /* default */].prototype.GLOBAL);

var loginTimeOutErrorCode = 'login_timeout_error';

/**
* 定义全局公用方法
*/
vue_esm["a" /* default */].prototype.http = function (opts) {
  var vue = this;
  if (opts.isShowLoading) {
    vue.$vux.loading.show({
      text: '加载中...'
    });
  }

  vue.$http({
    method: opts.method,
    url: opts.url,
    headers: opts.headers || {},
    params: opts.params || {},
    data: opts.data || {}
  }).then(function (response) {
    vue.$vux.loading.hide();

    opts.success(response);
  }).catch(function (error) {
    vue.$vux.loading.hide();
    console.log(error);
    if (!opts.error) {
      console.log(!opts.error);
      var response = error.response;
      var errorMessage = '请求失败';

      if (response && response.data) {

        if (response.data.code === loginTimeOutErrorCode) {
          window.location.href = '/';
        }
        errorMessage = response.data.message;
      }

      vue.$vux.alert.show({
        title: '提示',
        content: errorMessage

      });
    } else {
      console.log(opts.error(error.response.data.data));
      opts.error(error.response.data.data);
    }
  });
};

vue_esm["a" /* default */].prototype.get = function (opts) {
  opts.method = 'get';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.post = function (opts) {
  opts.method = 'post';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.put = function (opts) {
  opts.method = 'put';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.delete = function (opts) {
  opts.method = 'delete';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.valid = function (opts) {
  var vue = this;
  var valid = true;

  if (opts.ref && !opts.ref.valid) {
    valid = false;
  }

  if (opts.ignoreRefs) {
    var newRefs = [];
    for (var i in opts.refs) {
      var ref = opts.refs[i];
      for (var j in opts.ignoreRefs) {
        var ignoreRef = opts.ignoreRefs[j];
        if (ref !== ignoreRef) {
          newRefs.push(ref);
        }
      }
    }
    opts.refs = newRefs;
  }

  for (var _i in opts.refs) {
    if (!opts.refs[_i].valid) {
      valid = false;
      break;
    }
  }

  if (valid) {
    opts.success();
  } else if (opts.error) {
    opts.error();
  } else {
    vue.$vux.toast.show({
      text: '请检查输入'
    });
  }
};

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router_Index,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "SpE7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ssmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cUee":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d4Xq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hGGl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "itVq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lJuI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZdaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("qJoR")
}
var alert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (alert_Component.exports);


/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJoR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ruXm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ruXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ux2s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wwxo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xcCl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y0Os":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yt6H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.949dc4e37a5d6da0a267.js